export const chekRepublicTranslation = {
  'Les lignes de commandes ont été mises à jour avec succès !':
    'Příkazové řádky byly úspěšně aktualizovány!',
  'Le texte a été enregistré avec succès': 'Text byl úspěšně zaregistrován',
  'La traduction a été enregistrée avec succès': 'Překlad byl úspěšně uložen',
  'Texte + Traduction enregistré avec succès':
    'Text + Překlad byl úspěšně uložen',
  'Nombre de mots': 'Počet slov',
  Lingala: 'Lingala',
  'Prénom/Nom du client': 'Jméno/příjmení klienta',
  Bashkir: 'Baškirština',
  "La date doit être ultérieure à aujourd'hui.":
    'Datum musí být pozdější než dnes.',
  'Contenu rédigé': 'Napsaný obsah',
  'Nom/prénom': 'Příjmení/jméno',
  'Mot de passe incorrect': 'Nesprávné heslo',
  Institutions: 'Instituce',
  'Veuillez donner un descriptif au document téléchargé':
    'Uveďte prosím popis staženého dokumentu',
  'Sichuan Yi ; Nuosu': 'Sichuan Yi; Nuosu',
  Suivant: 'Další',
  Kannada: 'Kannada',
  'Séparer les mots clés par un "enter"':
    'Klíčová slova oddělujte klávesou "enter".',
  Allemand: 'Němčina',
  Sango: 'Sango',
  'Min.': 'Min.',
  'un email contenant un lien de réinitialisation du mot de passe a été envoyé à votre email':
    'na váš e-mail byl zaslán e-mail s odkazem na obnovení hesla.',
  'Chef edito': 'Šéfredaktor',
  Croate: 'Chorvatský',
  'Nb de textes': 'Počet textů',
  Violet: 'Violet',
  'Ce champs doit être sup ou égale nombre de texte':
    'Toto pole musí být větší nebo rovno počtu textů.',
  'a été activé avec succès': 'byl úspěšně aktivován',
  Népalais: 'Nepál',
  'Nombre de FAQ': 'Počet často kladených otázek',
  Urdu: 'Urdu',
  'Analyses restantes': 'Zbývající analýzy',
  Indonésien: 'Indonéský',
  Breton: 'Breton',
  Livrés: 'Doručeno na',
  Associations: 'Asociace',
  'Le client': 'Klient',
  'Révision demandée': 'Vyžádaná recenze',
  "Une erreur s'est produite, veuillez réessayer":
    'Došlo k chybě, zkuste to prosím znovu',
  'Mise à jour non autorisée car des textes ont été livrés':
    'Neautorizovaná aktualizace, protože texty byly doručeny',
  "Pour ajouter un texte (optimisation d'un contenu existant)":
    'Přidání textu (optimalizace stávajícího obsahu)',
  Gaélique: 'Gaelština',
  'La ligne de commande pour': 'Příkazový řádek pro',
  'Business/Management': 'Podnikání/řízení',
  Serbe: 'Srbština',
  "Merci d'indiquer ci-dessous vos demandes de modifications en prenant bien en compte nos conditions de repasses":
    'Níže prosím uveďte své požadavky na úpravy s ohledem na naše podmínky žehlení.',
  'rédacteurs trouvés': 'nalezených autoři',
  'Kirghiz ; Kirghiz': 'Kirgizové; Kirgiz',
  Différence: 'Rozdíl',
  'en cours': 'probíhá',
  'Sami du Nord': 'Severní Laponci',
  Comparer: 'Porovnat',
  Lituanien: 'Litevština',
  'Typix - Mon tableau de bord': 'Typix - Můj přístrojový panel',
  'Avoir au moins 8 caractères avec une lettre majuscule, un chiffre, un charactère spécial et ne pas être identique au nom':
    'Musí obsahovat alespoň 8 znaků, velké písmeno, číslici, speciální znak a nesmí být totožný se jménem.',
  Webmaster: 'Webmaster',
  'Veuillez saisir des champs valides': 'Zadejte prosím platná pole',
  Basque: 'Baskicko',
  'Exporter .csv': 'Export .csv',
  'Confirmer le nouveau mot de passe': 'Potvrzení nového hesla',
  "Pas d'options": 'Žádné možnosti',
  'Banque/Assurance': 'Bankovnictví/pojišťovnictví',
  'Vos demandes': 'Vaše požadavky',
  'Coût d\u2019achat': 'Nákupní náklady',
  Tamil: 'Tamil',
  'Le texte a été supprimé avec succès': 'Text byl úspěšně odstraněn',
  'Mes Commandes': 'Moje objednávky',
  Zoulou: 'Zulu',
  Afficher: 'Zobrazit',
  Texte: 'Text',
  Islandais: 'Islandské',
  Russe: 'Ruský',
  'Tous les textes': 'Všechny texty',
  Czech: 'Česky',
  'Comparaison hors ligne': 'Srovnání offline',
  Téléphonie: 'Telefonování',
  'Valider le texte': 'Ověření textu',
  'Votre text ne de doit pas dépasser 500 mots':
    'Váš text by neměl přesáhnout 500 slov',
  'Coquilles (double espace, « s »\u2026)': 'Skořápky (dvojitá mezera, "s"...)',
  'le consultant': 'konzultant',
  Coréen: 'Korejský',
  'Nb de Silo': 'Počet sil',
  Validés: 'Ověřeno',
  'non attribuées': 'nepřidělené',
  Néerlandais: 'Holandský',
  'Voulez-vous vraiment supprimer': 'Opravdu chcete odstranit',
  Rundi: 'Rundi',
  Regional: 'Regionální',
  'Compte client': 'Účet zákazníka',
  Global: 'Globální',
  'Tous les rôles': 'Všechny role',
  Musique: 'Hudba',
  Perso: 'Osobní',
  Kinyarwanda: 'Kinyarwanda',
  'Il semblerait que tu n\u2019aies plus de crédit d\u2019analyse':
    'Zdá se, že už nemáte žádný analytický kredit',
  Bambara: 'Bambara',
  Sortir: 'Vystupte',
  optionel: 'volitelné',
  'Temps restant': 'Zbývající čas',
  Ukrainien: 'Ukrajinský',
  'Chichewa ; Chewa ; Nyanja': 'Chichewa; Chewa; Nyanja',
  'Votre demande de révision a bien été envoyée.':
    'Vaše žádost o přezkoumání byla odeslána.',
  'Typix - Créer rédacteur': 'Typix - Vytvoření autoru',
  "n'existe pas": 'neexistuje',
  Hindi: 'Hindština',
  'ne peut pas être supprimé car il est lié à des sites web':
    'nelze smazat, protože je propojen s webovými stránkami',
  'Commandes en cours': 'Probíhající objednávky',
  'Textes livrés': 'Doručené texty',
  Validation: 'Ověřování',
  'Non attribuées': 'Nepřiděleno',
  'Voulez-vous vraiment désactiver': 'Opravdu chcete deaktivovat',
  'Catalan ; Valencien': 'katalánština; valencijština',
  'Nombre de textes restants': 'Počet zbývajících textů',
  'Ne doit pas contenir votre nom': 'Nesmí obsahovat vaše jméno',
  Documentation: 'Dokumentace',
  Kazakh: 'Kazachstán',
  'Numéro invalide': 'Neplatné číslo',
  'Veuillez saisir un texte ou importer un fichier.':
    'Zadejte text nebo importujte soubor.',
  'Nb de FAQ': 'Počet často kladených otázek',
  Analyser: 'Analýza',
  Turc: 'Turecký',
  'Toute demande n\u2019ayant pas été précisée lors du brief':
    'Veškeré požadavky, které nejsou uvedeny ve stručném popisu',
  Wallon: 'Valonsko',
  Birmane: 'Barmský',
  Irlandais: 'Irish',
  Oriya: 'Oriya',
  'Réinitialiservotre mot de passe': 'Obnovení hesla',
  Cuisine: 'Kuchyně',
  'Haïtien ; créole haïtien': 'haitština; haitská kreolština',
  'Vous ne pouvez pas supprimer le rédacteur': 'autor nelze odstranit',
  Validé: 'Ověřeno',
  "cet email n'existe pas": 'tento e-mail neexistuje',
  Historique: 'Historie',
  Confirmer: 'Potvrďte',
  'à cocher si le nombre de mots est différent par texte':
    'zaškrtnout, pokud se počet slov v textu liší.',
  'Fiche du site web ': 'Webový list',
  Désactiver: 'Deaktivace',
  'Travaux/BTP': 'Práce/stavební práce',
  'La fiche du website': 'Webový list',
  'Si le contenu ne respecte pas les règles du brief':
    'Pokud obsah nerespektuje pravidla zadání',
  Norvégien: 'Norština',
  '0 rédacteurs': '0 autoři',
  indisponible: 'nedostupné',
  Venda: 'Venda',
  Maori: 'Maori',
  'Textes revisés': 'Revidované texty',
  'Status texte': 'Stav textu',
  'textes livrés en attente de validation':
    'doručené texty čekající na ověření',
  'Typix - Mon Profile': 'Typix - Můj profil',
  'le client': 'klient',
  Romanche: 'Romanche',
  'URL du site': 'Adresa URL webu',
  'nouvelles notifications': 'nová oznámení',
  'Divehi ; Dhivehi ; Maldivien': 'Divehi; Dhivehi; Maledivy',
  'Êtes vous sur de vouloir sauvegarder le texte':
    'Jste si jisti, že chcete text uložit',
  'Veuillez ajouter un texte initiale afin de pouvoir sauvegarder le texte en brouillon':
    'Přidejte prosím počáteční text, abyste mohli text uložit jako návrh.',
  Xhosa: 'Xhosa',
  'Le contrat pour le client': 'Smlouva pro zákazníka',
  rédacteurs: 'autoři',
  'Ce champ est obligatoire': 'Toto pole je povinné',
  'Tarif/Mot': 'Sazba/slovo',
  Tadjik: 'Tádžik',
  'Réf devis': 'Odkaz na citaci',
  'Rechercher un rédacteur': 'Hledání autor',
  Albanais: 'Albánština',
  Galicien: 'Galicijský',
  Disponibilité: 'Dostupnost',
  'Les deux mots de passe ne sonts pas identiques': 'Obě hesla nejsou totožná',
  Tibétain: 'Tibeťan',
  'Typix - Gestion des utilisateurs': 'Typix - Správa uživatelů',
  'Ossétien ; Ossétique': 'Osetština; osetština',
  Tswana: 'Tswana',
  'Ajouter un client': 'Přidání zákazníka',
  'Séparez les mots-clés par un " Enter ".':
    'Klíčová slova oddělte klávesou "Enter".',
  'Zhuang ; Chuang': 'Zhuang; Chuang',
  Thématiques: 'Témata',
  'Nb mots/texte': 'Počet slov/textů',
  Commerce: 'Obchod',
  'Voir les commandes': 'Viz objednávky',
  'Nombre de mots par texte': 'Počet slov v textu',
  'Lien drive...': 'Odkaz pohon...',
  'Hollandais ; Flamand': 'nizozemština; vlámština',
  'Mon profil': 'Můj profil',
  "Ce champs doit être sup à 0 car facturation n'est pas au réel":
    'Toto pole musí být větší než 0, protože fakturace není skutečná.',
  'Le texte a été validé avec succès': 'Text byl úspěšně ověřen',
  Jeux: 'Hry',
  'Voulez-vous vraiment supprimer la ligne de commande pour':
    'Opravdu chcete odstranit příkazový řádek pro',
  'Ndebele, Nord ; Ndebele Nord': 'Ndebele, Sever; Ndebele North',
  'Slave ecclésiastique ; vieux slavon ; slavon ecclésiastique ; vieux bulgare ; vieux slavon ecclésiastique':
    'církevní slovanština; staroslověnština; církevní slovanština; stará bulharština; stará církevní slovanština',
  Swahili: 'Svahilština',
  Voyage: 'Cestování',
  'Nombre de mot à ajouter': 'Počet slov, která se mají přidat',
  'Liste des rédacteurs': 'Seznam autoři',
  'le rédacteur': 'autor',
  Kanuri: 'Kanuri',
  rédacteur: 'autor',
  Tatar: 'Tatar',
  'Roumain ; Moldave ; Moldovan': 'rumunština; moldavština',
  'Le texte initial de': 'Původní text',
  'Mail clients': 'Zákaznická pošta',
  'Le contrat de': 'Smlouva o',
  'au moins une lettre minuscule et une lettre majuscule,un caractère spécial et un chiffre':
    'alespoň jedno malé a jedno velké písmeno, jeden speciální znak a jednu číslici.',
  Transport: 'Doprava',
  'Nombre total de mots (existants et ajoutés) :':
    'Celkový počet slov (stávajících a přidaných) :',
  'Rechercher par mail, prénom, nom, site...':
    'Vyhledávání podle e-mailu, jména, příjmení, webu...',
  'Nombre de mot à ajouter (Min/Max) : ':
    'Počet slov, která mají být přidána (Min/Max) :',
  Compte: 'Účet',
  'Tourisme/Loisirs': 'Cestovní ruch/volný čas',
  'Nouveau texte': 'Nový text',
  Max: 'Max',
  'Kalaallisut ; Groenlandais': 'Kalaallisut; grónština',
  'Oups...!il y a une/plusieurs erreur(s) dans la fenêtre du gap sémantique. Veuillez vérifier son contenu pour la/les corriger et soumettre à nouveau votre texte.':
    'Ups...! V okně sémantické mezery je jedna nebo více chyb. Zkontrolujte prosím jeho obsah, opravte jej/je a znovu odešlete svůj text.',
  'ne peut pas être supprimé pour le moment': 'nelze v tuto chvíli vymazat',
  'Le texte': 'Text',
  URL: 'ADRESA URL',
  "Un utilisateur existe déjà avec l'email":
    'Uživatel s tímto e-mailem již existuje',
  Cree: 'Cree',
  Prénom: 'Křestní jméno',
  'commandes prête': 'připravené objednávky',
  Réinitialiser: 'Obnovení',
  'Veuillez fournir une date valide': 'Uveďte prosím platné datum',
  'Kuanyama ; Kwanyama': 'Kuanyama; Kwanyama',
  'Luxembourgeois ; Letzeburgesch': 'Lucemburština; Letzeburgesch',
  Suédois: 'Švédský',
  'Confirmer le mot de passe': 'Potvrzení hesla',
  'Ce champs est obligatoire et ne peut avoir que des nombres':
    'Toto pole je povinné a může obsahovat pouze čísla',
  Sciences: 'Věda',
  Tchétchène: 'Čečensko',
  "est le seul client pour un site, il faut ajouter d'autres pour pouvoir le supprimer":
    'je jediným klientem webu, pro jeho odstranění je třeba přidat další.',
  'Le mot de passe de confirmation ne correspond pas':
    'Potvrzovací heslo se neshoduje',
  Swati: 'Swati',
  Danois: 'Dánský',
  Sauvegarder: 'Uložit',
  'Veuillez changer les informations suivantes titre et/ou mot clé':
    'Změňte prosím následující informace: název a/nebo klíčové slovo',
  'importer un document': 'importovat dokument',
  Maltais: 'Maltský',
  'Nb de mots': 'Počet slov',
  'Les données fournies sont invalides': 'Poskytnuté údaje jsou neplatné',
  'Livraison estimée': 'Odhadované dodání',
  'Grec moderne (1453-)': 'Moderní řečtina (1453-)',
  Avestan: 'Avestánština',
  Inuktitut: 'Inuktitut',
  'Nombre total de mots ajoutés': 'Celkový počet přidaných slov',
  'le contenu présente des inexactitudes': 'obsah obsahuje nepřesnosti',
  Finnois: 'Finsko',
  'Ajouter un admin': 'Přidání správce',
  'Min/Max': 'Min/Max',
  'Modifier le consultant': 'Úprava konzultanta',
  'Liste des clients': 'Seznam klientů',
  'Nom client': 'Jméno zákazníka',
  Vert: 'Zelená',
  'Mots clés manquants': 'Chybějící klíčová slova',
  Lao: 'Lao',
  Somali: 'Somálsko',
  'Nb de silo par texte': 'Počet sil na text',
  Italien: 'Italský',
  'La commande a été mis à jour avec succès !':
    'Objednávka byla úspěšně aktualizována!',
  Bosniaque: 'Bosenský',
  'Thématiques d\u2019expertise': 'Témata odborných znalostí',
  'Ce mot de passe est le mot de passe que vous avez oublié':
    'Toto je heslo, které jste zapomněli',
  'a été désactivé avec succès': 'byl úspěšně deaktivován',
  Kongo: 'Kongo',
  'Postuler à la commande': 'Požádat o objednávku',
  'mot-clé': 'klíčové slovo',
  Abkhazien: 'Abcházie',
  Mongolien: 'Mongolský',
  'Typix - Fiche site web': 'Typix - Webové stránky',
  'Mail envoyé': 'Odeslaná pošta',
  Géorgien: 'Gruzínština',
  'Si des phrases ne sont pas dans un français correct':
    'Pokud věty nejsou ve správné francouzštině',
  'En cours': 'Probíhá',
  voir: 'viz',
  "Date d'ajout": 'Datum přidání',
  'Tarif au mot': 'Sazba za slovo',
  Thai: 'Thai',
  'Détails du texte': 'Podrobnosti o textu',
  'Commandes en retard': 'Pozdní objednávky',
  disponible: 'k dispozici na',
  Droit: 'Právo',
  Azerbaïdjanais: 'Ázerbájdžán',
  'Ajouter un consultant': 'Přidání konzultanta',
  'Dans le cadre d\u2019une repasse sur des contenus, seuls les éléments suivants seront pris en charge':
    'Při přehrávání obsahu budou podporovány pouze následující položky.',
  'doit comprendre au moins 8 charactères': 'musí obsahovat alespoň 8 znaků',
  'Titre de la commande': 'Název zakázky',
  'Langues bihari': 'Bihárské jazyky',
  'Livraison estimé au': 'Předpokládané dodání do',
  "Le nombre de texte de la commande ne peut pas être inférieur aux nombre de textes attribuées au(x) rédacteur(s). Veuillez d'abord modifier les informations de la ligne de commande":
    'Počet textů v objednávce nesmí být menší než počet textů přidělených autorovi (autorům). Nejprve změňte informace v příkazovém řádku',
  'Date de livraison': 'Datum dodání',
  'Voulez-vous vraiment supprimer le contrat de': 'Opravdu chcete zrušit',
  'Facturation au réel': 'Skutečné vyúčtování',
  'Gap sémantique': 'Sémantická mezera',
  Estonien: 'Estonština',
  Wolof: 'Wolof',
  'Coût d\u2019achat max/mot': 'Maximální pořizovací cena/slovo',
  'Détail de la commande': 'Podrobnosti o objednávce',
  'Export en cours de téléchargement\u2026': 'Nahrávání exportu...',
  'Ce champ est obligatoire et doit être inférieur ou égal au Nombre total des textesde la commande':
    'Toto pole je povinné a musí být menší nebo rovno celkovému počtu textů v objednávce.',
  Arabe: 'Arabština',
  Bislama: 'Bislama',
  'Mail client': 'Zákaznická pošta',
  '(Titre, mot clé, url, balise, méta-description)':
    '(Title, keyword, url, tag, meta-description)',
  'Typix - Nouvelle commande': 'Typix - Nová objednávka',
  'Révision en attente': 'Recenze probíhá',
  'Le consultant': 'Konzultant',
  Entreprise: 'Společnost',
  Aragonais: 'Aragonský',
  Kashmiri: 'Kašmír',
  'a été activé': 'byl aktivován',
  'Interlingua (Association internationale des langues auxiliaires)':
    'Interlingua (Mezinárodní asociace pomocných jazyků)',
  Actualités: 'Zprávy',
  'Votre décision a été prise en compte avec succès':
    'Vaše rozhodnutí bylo úspěšně zohledněno',
  Afrikaans: 'Afrikánština',
  'contenu en attente de vérification client':
    'obsah čeká na ověření zákazníkem',
  'Fiche du rédacteur': 'Soubor autora',
  Outillage: 'Nástroje',
  'Typix - Détails de la commande': 'Typix - Order details',
  'Ajouter ou compléter ci-dessous votre contenu :':
    'Níže přidejte nebo doplňte svůj obsah:',
  Ewe: 'Ewe',
  'contenu en attente de repasse rédacteur':
    'autor přehrávání obsahu v očekávání',
  'La commande a été supprimé avec succès': 'Objednávka byla úspěšně smazána',
  'Expressions ou phrases françaises mais ne vous convenant pas':
    'Francouzské výrazy nebo fráze, které vám nevyhovují',
  Corse: 'Korsika',
  Modifier: 'Upravit',
  'Nb de GMB': 'Počet GMB',
  Oromo: 'Oromo',
  Polish: 'Polský',
  'Insérez votre gap sémantique avec l’occurrence ainsi que le maillage interne':
    'Vložte svou sémantickou mezeru s výskytem',
  'Nb de textes à optimiser': 'Počet textů k optimalizaci',
  Mode: 'Režim',
  Akan: 'Akan',
  'Révisions effectués': 'Provedené revize',
  'Modifier l\u2019admin': 'Upravit správce',
  'Télécharger le document': 'Stáhnout dokument',
  Hausa: 'Hausa',
  'Notes rédacteurs': 'Poznámky autoři',
  Quechua: 'Quechua',
  Féroïen: 'Faerské ostrovy',
  'Modifier le rédacteur': 'Změna autoru',
  Mail: 'Mail',
  Rédacteurs: 'autoři',
  'Typix - Détails du texte': 'Typix - Podrobnosti o textu',
  Hongrois: 'Maďarština',
  'Bon pour livraison': 'Dobré pro doručení',
  'Au réel': 'V reálném světě',
  'Hiri Motu': 'Hiri Motu',
  Hébreu: 'Hebrejština',
  'Nombre total de mots ajoutés :': 'Celkový počet přidaných slov :',
  Komi: 'Komi',
  'Doit être inférieur au nombre maximum': 'Musí být menší než maximální počet',
  'Nom du texte': 'Název textu',
  'Ajouter un rédacteur': 'Přidání autoru',
  Ou: 'Nebo',
  Utilisateurs: 'Uživatelé',
  Heures: 'Hodiny',
  'Santé/Bien-être': 'Zdraví/pohoda',
  'Interlingue ; Occidental': 'Mezijazykové; západní',
  'Luba-Katanga': 'Luba-Katanga',
  Letton: 'Lotyšský',
  Anglais: 'Angličtina',
  Envoyer: 'Odeslat',
  'Tableau de bord': 'Přístrojová deska',
  'Demande de révision': 'Žádost o přezkum',
  'Résultat sémantique': 'Sémantický výsledek',
  'Chercher un rédacteur': 'Hledání autora',
  'Ce champs est obligatoire': 'Toto pole je povinné',
  Rédaction: 'Redakce',
  'Modifier le client': 'Úprava klienta',
  'Voulez-vous vraiment supprimer le rédacteur':
    'Opravdu chcete odstranit autor',
  Titre: 'Název',
  Langue: 'Jazyk',
  'Les demandes suivantes ne seront pas prises en compte':
    'Následující žádosti nebudou posuzovány',
  'délai dépassé': 'promeškaná lhůta',
  Tchouvache: 'Tchouvache',
  Ganda: 'Ganda',
  Twi: 'Twi',
  'Contrat déjà existant, veuillez modifier les informations':
    'Stávající smlouva, upravte prosím informace',
  Igbo: 'Igbo',
  Yiddish: 'Jidiš',
  'Limburgan ; Limburger ; Limburgish': 'Limburgan; Limburger; Limburgish',
  'Commandes validées': 'Ověřené objednávky',
  'listeRedacteur-': 'listRedactor-',
  Étape: 'Krok',
  'Energie/Environnement': 'Energie/životní prostředí',
  Min: 'Min',
  Gujarati: 'Gudžarátština',
  'ne doit pas inclure votre nom/prénom': 'nesmí obsahovat vaše jméno/jméno',
  'Typix - Fiche rédacteur': 'Typix - Soubor autor',
  'révisions effectuées en attentes de validation':
    'provedené revize čekající na ověření',
  'Textes validés': 'Ověřené texty',
  Art: 'Art',
  Dzongkha: 'Dzongkha',
  Polyvalent: 'Všestranný',
  Sundanese: 'Sundanese',
  'Nb total de textes': 'Celkový počet textů',
  'Nombre de mots gérés': 'Počet spravovaných slov',
  "L'émail": 'Smalt',
  'Afficher les résultats': 'Zobrazit výsledky',
  'Frison occidental': 'západofríština',
  'Modification effectuée avec succès': 'Úprava byla úspěšně dokončena',
  'Balise titre': 'Značka Title',
  'Typix - Mon profil': 'Typix - Můj profil',
  'email invalide': 'neplatný e-mail',
  'Veuillez ajouter une url afin de pouvoir sauvegarder le texte en brouillon':
    'Přidejte prosím url adresu, abyste mohli text uložit jako návrh.',
  Macédonien: 'Makedonština',
  'Votre candidature a bien été envoyée': 'Vaše žádost byla odeslána',
  'E-mail': 'E-mail',
  Fulah: 'Fulah',
  'Ajouter ou compléter ci-dessous votre contenu':
    'Přidejte nebo doplňte svůj obsah níže',
  Manx: 'Manx',
  'Ajout de mots-clés avec la fréquence restante':
    'Přidání klíčových slov se zbývající frekvencí',
  'Fiche du site web': 'Webový list',
  Contacter: 'Kontakt',
  Fidjien: 'Fidži',
  Déconnexion: 'Odpojení',
  email: 'e-mail',
  'Nombre de textes': 'Počet textů',
  'Enregistrer et informer client': 'Registrace a informování zákazníků',
  'Date de validation': 'Datum ověření',
  'Tonga (Îles Tonga)': 'Tonga (Tongské ostrovy)',
  Javanais: 'Javánština',
  Portugais: 'Portugalština',
  Biélorusse: 'Běloruský',
  'Pour ajouter un nouveau texte': 'Přidání nového textu',
  'Enfant/Puéri': 'Dítě/Pupium',
  'Mots clés': 'Klíčová slova',
  Emploi: 'Zaměstnání',
  'Voulez-vous vraiment supprimer la commande de': 'Opravdu chcete odstranit',
  'Mot clé': 'Klíčové slovo',
  Consultants: 'Poradci',
  Volapük: 'Volapük',
  Services: 'Služby',
  'mot-clé (fréquence)': 'klíčové slovo (frekvence)',
  'Ne plus afficher ce message': 'Tuto zprávu již nezobrazujte',
  Consultant: 'Konzultant',
  "Une erreur s'est produite": 'Došlo k chybě',
  'Avoir au moins 8 caractères avec une lettre majuscule, un chiffre, un charactère spécial':
    'Alespoň 8 znaků s velkým písmenem, číslicí, speciálním znakem.',
  'Pushto ; Pashto': 'Puštunština; paštunština',
  Français: 'Francouzština',
  validées: 'ověřeno',
  'Url du site': 'Url stránky',
  Précédent: 'Předchozí',
  'car celui-ci a déjà rédigé des textes': 'protože ten již vypracoval texty',
  'Kikuyu ; Gikuyu': 'Kikuyu; Gikuyu',
  Brouillons: 'Návrhy',
  Ido: 'Ido',
  'Contenu disponible': 'Dostupný obsah',
  Enseignement: 'Výuka',
  'a été livré avec succès': 'byla úspěšně doručena',
  Chinois: 'Čínský',
  Vietnamien: 'Vietnamci',
  'Nouveau client': 'Nový zákazník',
  'Votre profil a été mis à jour avec succès.':
    'Váš profil byl úspěšně aktualizován.',
  Consignes: 'Pokyny',
  'Mot de passe': 'Heslo',
  Annuler: 'Zrušit',
  Non: 'Ne',
  Nom: 'Název',
  Guarani: 'Guarani',
  "il y'a des commandes liés à au site web":
    'existují zakázky související s webovými stránkami',
  Score: 'Skóre',
  'Mot de passe mis à jour avec succès': 'Heslo bylo úspěšně aktualizováno',
  Latin: 'Latinský',
  Technologie: 'Technologie',
  Internet: 'Internet',
  Nauru: 'Nauru',
  'a été créé avec succès': 'byl úspěšně vytvořen',
  Roumain: 'Rumunština',
  Assamais: 'Assamese',
  'Khmer central': 'Střední Khmerové',
  'Navajo ; Navaho': 'Navajo; Navaho',
  'Panjabi ; Punjabi': 'Paňdžábština; paňdžábština',
  'Analyse/Limite': 'Analýza/limit',
  Grec: 'Řecký',
  Ojibwa: 'Ojibwa',
  'Mes Projets': 'Moje projekty',
  'keyword1 (2)\nkeyword2 (1)\nkeyword3 (1)\nkeyword4 (2)\n\u2026':
    'klíčové slovo1 (2)\nklíčové slovo2 (1)\nklíčové slovo3 (1)\nklíčové slovo4 (2)\n...',
  'ajouter un texte': 'přidat text',
  'Détail de la prestation': 'Podrobnosti o službě',
  "Vous avez la possibilité d'exporter le rapport d'une, ou de plusieurs commandes. Pour exporter toutes les commandes d'un client, il vous suffit juste de cliquer sur l'icône de téléchargement en jaune":
    'Máte možnost exportovat sestavu jedné nebo více objednávek. Chcete-li exportovat všechny objednávky zákazníka, stačí kliknout na žlutou ikonu pro stažení.',
  'Gestion des utilisateurs': 'Správa uživatelů',
  'livré et inférieur au nombre de texte non affecté':
    'a méně než počet nepřidělených textů.',
  'Date deadline validation client': 'Lhůta pro ověření zákazníka',
  Aymara: 'Aymara',
  Validées: 'Ověřeno',
  Notes: 'Poznámky',
  'Nombre de GMB': 'Počet GMB',
  'résultats sur': 'výsledky na',
  'Prénom / Nom du client': 'Křestní jméno / Jméno klienta',
  'Tout télécharger': 'Stáhnout vše',
  'Champs obligatoires': 'Povinná pole',
  Éditer: 'Upravit',
  'Coller le texte initial dans le champs ci-dessous':
    'Vložte původní text do pole níže',
  'ID rédacteur': 'ID autora',
  Arménien: 'Arménština',
  'Grande distribution': 'Velkoplošná distribuce',
  Welsh: 'Velština',
  Herero: 'Herero',
  'Enrichissement sémantique': 'Sémantické obohacení',
  'Détail de la prestation du contenu': 'Podrobnosti o poskytování obsahu',
  Noir: 'Černá',
  'Ajouter un texte': 'Přidání textu',
  Traduction: 'Překlad',
  'Immo/Defisc': 'Majetek/daň',
  'Brief détaillé': 'Podrobná stručná informace',
  'Séparez les mots-clés par un Enter .':
    'Klíčová slova oddělte klávesou Enter .',
  Prix: 'Ocenění',
  'mot de passe oublié': 'Zapomenuté heslo',
  'Ndebele, South ; South Ndebele': 'Ndebele, Jižní; Jižní Ndebele',
  'Demander une révision': 'Vyžádat si recenzi',
  'Demander une repasse globale': 'Požádat o celkovou revizi',
  'Sotho, Southern': 'Sotho, jižní',
  'Le titre de la commande existe déjà': 'Název zakázky již existuje',
  'Félicitations !': 'Gratulujeme!',
  Kurde: 'Kurdové',
  Adresse: 'Adresa',
  Espagnol: 'Španělština',
  Ndonga: 'Ndonga',
  'En retard': 'Pozdě',
  'a été ajouté avec succès': 'byl úspěšně přidán',
  Commandes: 'Ovládací prvky',
  'a été mis en brouillon': 'byl vypracován',
  'Rédacteur attribué': 'Přidělený autor',
  Rechercher: 'Vyhledávání',
  'Nouvelle commande': 'Nová objednávka',
  'Commandes non attribuées': 'Nepřidělené zakázky',
  'Le texte a été mis en brouillon': 'Text byl vypracován',
  'Contact edito': 'Kontaktovat edito',
  Langues: 'Jazyky',
  Orange: 'Orange',
  'Nynorsk norvégien': 'Norština Nynorsk',
  Shona: 'Shona',
  Turkmène: 'Turkmen',
  'contenu repassé, en attente validation client':
    'vyžehlený obsah, který čeká na ověření zákazníkem.',
  'Nombre de mots rédigés': 'Počet napsaných slov',
  Malay: 'Malajština',
  'Nombre de Silo': 'Počet sil',
  Oui: 'Ano',
  Automobile: 'Automobilový průmysl',
  Résultats: 'Výsledky',
  Afar: 'Afar',
  'Tâche - id tâche': 'Task - id úlohy',
  'Ce champ est obligatoire doit être supérieur à 0':
    'Toto pole je povinné a musí být větší než 0.',
  'Vous êtes sûr': 'Jste si jistý, že',
  'Réinitialiser votre mot de passe': 'Obnovení hesla',
  Sindhi: 'Sindhi',
  Bengali: 'Bengálština',
  'Bokmål, norvégien ; Bokmål norvégien': 'Bokmål, norština; Norwegian Bokmål',
  'Nombre de Jours': 'Počet dní',
  'Min/Max mots': 'Min/Max slova',
  Slovène: 'Slovinština',
  Site: 'Webové stránky',
  'Sinhala ; Cingalais': 'Sinhálština; sinhálština',
  Bulgare: 'Bulharský',
  'Liste des commandes': 'Seznam objednávek',
  "L'utilisateur": 'Uživatel',
  Uzbek: 'Uzbek',
  'Titre du texte': 'Název textu',
  Postuler: 'Přihlaste se na',
  'Nb de textes par Silo': 'Počet textů na silo',
  'Nombre total de mots (existants et ajoutés)':
    'Celkový počet slov (stávajících a přidaných)',
  'Max.': 'Max.',
  Beauté: 'Krása',
  Humanitaire: 'Humanitární',
  Telugu: 'Telugu',
  'Recherche par rédacteur ou texte': 'Hledat podle autora nebo textu',
  'Balise meta-description': 'Meta description tag',
  Malgache: 'Madagaskar',
  Tagalog: 'Tagalog',
  'Ce champs doit être sup à 0 et inférieur à 1':
    'Toto pole musí být větší než 0 a menší než 1.',
  'Le rédacteur': 'Redaktor',
  'a été mis à jour avec succès': 'byl úspěšně aktualizován',
  'Avoir au moins 8 caractères avec une lettre majuscule, un chiffre, un symbole et ne pas être identique au nom.':
    'Musí obsahovat alespoň 8 znaků, velké písmeno, číslici, symbol a nesmí být totožný se jménem.',
  'textes en plus': 'další texty',
  'Format souhaité': 'Požadovaný formát',
  Chamorro: 'Chamorro',
  Malayalam: 'Malayalam',
  'Détail ligne de commande': 'Detail řádku objednávky',
  'Veuillez préciser la date': 'Uveďte prosím datum',
  Pali: 'Pali',
  Clients: 'Zákazníci',
  'Total facturé': 'Fakturováno celkem',
  'contenu validé par le client': 'obsah ověřený klientem',
  'Occitan (post 1500)': 'okcitánština (po roce 1500)',
  Japonais: 'Japonský',
  Avaric: 'Avaric',
  'Voulez-vous vraiment activer': 'Opravdu chcete aktivovat',
  Sanskrit: 'Sanskrt',
  'Toutes les notifications': 'Všechna oznámení',
  Marathi: 'Maráthština',
  Persan: 'Perský',
  'La commande pour le client': 'Objednávka pro zákazníka',
  'Intitulé de la commande': 'Název zakázky',
  Samoan: 'Samoan',
  Autres: 'Další',
  Sport: 'Sport',
  "il y'a des commandes liés au site web ":
    'existují zakázky související s webovými stránkami',
  'Ajout de mots-clé avec la fréquence restante':
    'Přidání klíčových slov se zbývající frekvencí',
  'a été supprimé avec succès': 'byl úspěšně odstraněn',
  Postulé: 'Posted',
  Literie: 'Povlečení',
  'Édité par le client': 'Upraveno klientem',
  Cornouailles: 'Cornwall',
  Tigrinya: 'Tigrinya',
  Textes: 'Texty',
  'Soumettre un nouveau texte': 'Odeslání nového textu',
  Téléphone: 'Telefon',
  Deadline: 'Termín',
  "Une erreur s'est produite. Veuillez vérifier votre saisie ou essayer plus tard.":
    'Došlo k chybě. Zkontrolujte prosím zadání nebo to zkuste později.',
  Marshallais: 'Marshall',
  "La demande d'ajout de crédit est envoyée":
    'Žádost o připsání kreditu je odeslána',
  'Le rédacteur ': 'Redaktor',
  'Demander des crédits': 'Žádost o úvěr',
  "Cette commande n'existe pas": 'Tento příkaz neexistuje',
  Inupiaq: 'Inupiaq',
  Tahitien: 'Tahitian',
  Admins: 'Administrátoři',
  'Mettez des mots-clés avec fréquence': 'Nastavení klíčových slov s frekvencí',
  Notifications: 'Oznámení',
  'en retard': 'pozdě',
  "l'admin": 'správce',
  'Mail rédacteurs': 'autoři pošty',
  Amharique: 'Amharština',
  Societe: 'Společnost',
  Tsonga: 'Tsonga',
  'Nombre de textes ajoutés': 'Počet přidaných textů',
  Société: 'Společnost',
  Yoruba: 'Yoruba',
  'Le texte a été livré avec succès': 'Text byl úspěšně doručen',
  'Mettez votre texte': 'Vložte svůj text',
  "Oups....! Une erreur s'est produite": 'Oops....! Došlo k chybě',
  'Prénom/Nom': 'Jméno/příjmení',
  'Max doit être sup à Min': 'Max musí být větší než Min',
  'Importer un autre document': 'Import jiného dokumentu',
  'Votre demande a expirée .. veuillez refaire une autre':
    'Platnost vaší žádosti vypršela... vytvořte prosím novou.',
  'Veuillez corriger le format de votre gap sémantique afin de pouvoir sauvegarder le texte en brouillon':
    'Opravte prosím formát sémantické mezery, abyste mohli text uložit jako návrh.',
  Exemple: 'Příklad',
  Slovaque: 'Slovenská',
  Finance: 'Finance',
  Réactiver: 'Znovu aktivovat',
  'Nb textes': 'Počet textů',
  'Intitulé commande': 'Název objednávky',
  Supprimer: 'Odstranit',
  Brouillon: 'Návrh',
  'Mots clés restants': 'Zbývající klíčová slova',
  Date: 'Datum',
  Rôle: 'Role',
  'Ce champs doit être sup à 0': 'Toto pole musí být větší než 0',
  'Maison/Déco': 'Domov/Dekor',
  'Vous avez': 'Máte',
  'Cette ligne de commande ne peut pas être supprimée car une partie de ses textes a été livré':
    'Tento příkazový řádek nelze odstranit, protože část jeho textu byla doručena.',
  'vérifiez votre email et cliquez sur le lien pour continuer !':
    'zkontrolujte svůj e-mail a klikněte na odkaz pro pokračování!',
  Sarde: 'Sardinie',
  'Note rédacteur': 'Poznámka redakce',
  'Uighur ; Uyghur': 'Ujgurština; Ujgurština',
  Name: 'Název',
  'Commandes intelligentes': 'Smart příkazy',
  'Commandes avec révision': ' Smart + review příkazy',
  'Type de contenu': 'Typ obsahu',
  'Fiche produit': 'Produktový list',
  GMB: 'GMB',
  'STORE LOCATOR': 'STORE LOCATOR',
  'Rédaction premium': 'Premium redakce',
  'Rédaction avec révision': 'Smart + review redakce',
  'Rédaction intelligente': 'Smart redakce',
  'Traduction premium': 'Prémiový překlad',
  PREMIUM: 'PREMIUM',
  Type: 'Typ',
  Editer: 'Upravit',
  'Tous les types': 'Všechny typy',
  Smart: 'Smart',
  'Smart + review': 'Smart + review',

  'Factures traitées': 'Zpracované faktury',
  'Factures à valider': 'Faktury k validaci',
  'Impossible de générer la facture ! Veuillez réessayer':
    'Generování faktury se nezdařilo! Prosím, zkuste to znovu',
  'Récapitulatif de facturation': 'Souhrn fakturace',
  'Demander une modification': 'Požádat o úpravu',
  'Valider et envoyer la facture': 'Potvrdit a odeslat fakturu',
  'Demande de modification': 'Žádost o úpravu',
  'La facture a été validé avec succès!': 'Faktura byla úspěšně potvrzena!',
  "Oups un erreur c'est produit!": 'Ups, došlo k chybě!',
  'Nombre de texte': 'Počet textů',
  'Nombre de mot par texte :': 'Počet slov na textu:',
  Paiement: 'Platba',
  Virement: 'Převod',
  Délai: 'Termín',
  'Référence de votre facture': 'Odkaz na vaši fakturu',
  'Coût au mot': 'Cena za slovo',
  'Montant global de la commande': 'Celková částka objednávky',
  'Votre facture': 'Vaše faktura',
  'Importer votre facture': 'Importovat vaši fakturu',
  'Pas de fichier disponible': 'Žádný dostupný soubor',
  Télécharger: 'Stáhnout',
  Relancer: 'Opakované zaslání',
  'Générer la facture': 'Vygenerovat fakturu',
  Payée: 'Zaplaceno',
  'En cours de paiement': 'Probíhá platba',
  'En cours de validation': 'Probíhá validace',
  'En cours de modification': 'V procesu úpravy',
  'A envoyer': 'K odeslání',
  'Modification demandée': 'Požadována úprava',
  'Référence de facture est obligatoire': 'Odkaz na fakturu je povinný',
  'Le coût au mot doit être un nombre': 'Cena za slovo musí být číslo',
  'Le coût au mot doit être un nombre positif':
    'Cena za slovo musí být kladné číslo',
  'Le coût au mot est obligatoire': 'Cena za slovo je povinná',
  'Le montant global de la commande doit être un nombre':
    'Celková částka objednávky musí být číslo',
  'Le montant global de la commande doit être un nombre positif':
    'Celková částka objednávky musí být kladné číslo',
  'Le montant global de la commande est obligatoire':
    'Celková částka objednávky je povinná',
  'Bill reference existe déja , veuillez réessayer':
    'Odkaz na fakturu již existuje, prosím, zkuste to znovu',
  'La facture a été envoyée avec succès!': 'Faktura byla úspěšně odeslána!',

  'Montant estimé': 'Odhadovaná částka',
  Action: 'Akce',
  Facture: 'Faktura',
  Statut: 'Stav',
  Factures: 'Faktury',
  'Valider la facture': 'Ověřit fakturu',
  'La relance a été envoyée avec succès !': 'Výzva byla úspěšně odeslána!',
  'La demande de modification a été envoyée avec succès !':
    'Žádost o úpravu byla úspěšně odeslána!',
  'Le cout est trop élevé': 'Cena je příliš vysoká',
  'Le montant global de la commande est trop élevé ':
    'Celková částka objednávky je příliš vysoká',
  jours: 'dny',
  'Factures à envoyer': 'Faktury k odeslání',
  'Valider le paiment': 'Potvrdit platbu',
  'Générer une facture': 'Generovat fakturu',
  'Montant rédacteur': 'Částka pro redaktora',
  'Montant estimé par Typix': 'Odhadovaná částka Typixem',
  'Voir la modification': 'Zobrazit úpravu',

  'Tag de Titre': 'Titulkový tag',
  'Meta description': 'Meta popis',
  'Nom du produit': 'Název produktu',
  Avantages: 'Výhody',
  'Description détaillée': 'Podrobný popis',
  'Mes Factures': 'Moje faktury',
  'En attente de validation': 'Čeká na schválení',
  'les valeurs négatives ne sont pas autorisées':
    'Negativní hodnoty nejsou povoleny.',
  'Texte Seulement': 'Pouze text',
  'Traduction Seulement': 'Pouze překlad',
  'La relance peut être faite 20 jours après la soumissions de la facture':
    'Připomínka může být zaslána 20 dní po odeslání faktury',
  'Verifier la facture': 'Zkontrolujte fakturu',
  Instructions: 'Instrukce',
  'Votre avis pour la commande': 'Váš názor na objednávku',
  'Votre évaluation est précieuse pour nous ! Merci !':
    'Vaše hodnocení je pro nás cenné! Děkujeme!',
  "Une erreur s'est produite lors de la soumission de votre évaluation. Veuillez réessayer ultérieurement!":
    'Při odesílání vašeho hodnocení došlo k chybě. Prosím, zkuste to později!',
  Evaluer: 'Hodnotit',
  Commentaire: 'Komentář',
  'Votre commantaire': 'Váš komentář',
  Note: 'Hodnocení',
  'Votre retour est précieux pour nous et nous aide à améliorer nos services.':
    'Vaše zpětná vazba je pro nás cenná a pomáhá nám vylepšovat naše služby.',

  ' Votre retour est précieux pour nous et nous aide à améliorer nos services. Merci de partager votre évaluation avec nous!':
    'Vaše zpětná vazba je pro nás cenná a pomáhá nám zlepšovat naše služby. Děkujeme, že ji sdílíte s námi!',
  'Notes rédacteur': 'Poznámky autora',
  'Avis client': 'Hodnocení zákazníka',
  'Pas de commantaire': 'Žádný komentář',
  "Qu'avez vous pensé de votre commande?": 'Co si myslíte o vaší objednávce?',
  'Evaluation de la commande': 'Hodnocení objednávky',
  'Rédiger un commentaire': 'Napsat komentář',
  'Contribuez à nous permettre de vous proposer les services de rédaction de la plus haute qualité en partageant vos commentaires.':
    'Pomozte nám nabízet vám služby psaní nejvyšší kvality tím, že sdílíte své komentáře.',
  'Que pouvons-nous améliorer?': 'Co můžeme zlepšit?',
  Continuer: 'Pokračovat',
  'Le dernier texte a été validé avec succès':
    'Poslední text byl úspěšně ověřen',
  'Rechercher par rédacteur, commandes, et montant':
    'Vyhledávat podle redaktora, objednávek a částky',
  obligatoire: 'povinný',
  'Note admin': 'Poznámka administrátora',
  'Note client': 'Poznámka klienta',
  Partie: 'Část',
  'Vous venez de valider tous les contenus rédigés par ':
    'Právě jste schválil všechen obsah napsaný ',
  "Qu'en avez vous pensé": 'Co jste si o tom mysleli',
  'Lafacture a été générée avec succès !': 'Faktura byla úspěšně vygenerována!',
  'La taille du titre et/ou la méta-description est trop courte':
    'Délka nadpisu a/nebo meta popisu je příliš krátká',
  'Demande de révision globale': 'Vyžadovat celkovou revizi',
  Valider: 'Ověřit',
  'Obligatoire en cas d’optimisation ou traduction':
    'Povinné v případě optimalizace nebo překladu',
  'Mots clés Bourrées': 'Keyword stuffing',
  'Votre commentaire...': 'Váš komentář...',
  'Ex : "Contenus de très bonne qualité': 'Např.: "Velmi kvalitní obsah"',
  "pouvez-vous s'il vous plaît reprendre ce/tte rédacteur/rice pour les prochaines commandes?":
    'Můžete, prosím, tohoto autora přidělit pro budoucí objednávky?',
  'Ce bouton est pour informer le client que le texte initial, contenait déjà du keyword stuffing':
    'Toto tlačítko slouží k informování klienta, že původní text již obsahoval nadměrné použití klíčových slov',
  'Maillage Interne': 'Internal link',
  'Modifier le texte': 'Upravit text',
  Ajouter: 'Přidat',
  'Demande examen': 'Žádost o zkoušku',
  'Recherche de mots clés à haute densité': 'Hledání keyword stuffing',
  'Oups, il semblerait qu’il y ait du keyword stuffing dans votre texte : ':
    'Oops, zdá se, že ve vašem textu je keyword stuffing: ',
  'Oups, il semblerait qu’il y ait du keyword stuffing (trop d’occurrences d’un ou plusieurs mots clés) dans le texte initial.':
    'Oops, zdá se, že v původním textu je keyword stuffing (příliš mnoho výskytů jednoho nebo více klíčových slov).',
  'Merci de vous assurer que la densité des mots clés soit optimisée pour le SEO (une occurrence maximum tous les 50 mots).':
    'Prosím, ujistěte se, že hustota klíčových slov je optimalizována pro SEO (maximálně jedna výskyt každých 50 slov).',
  'Pour cela merci de ne pas retoucher le texte existant et de bien vouloir envoyer une demande d’examen au support.':
    'Pro toto, prosím neupravujte stávající text a laskavě pošlete žádost o zkoušku na podporu.',
  'Votre demande a été bien envoyée !': 'Vaše žádost byla úspěšně odeslána!',
  "Il y a eu un problème lors de l'envoi de votre demande":
    'Při odesílání vašeho požadavku nastal problém.',
  'Veuillez attendez pour le  keyword Stuffing analyse':
    'Čekejte prosím na analýzu keyword stuffing.',
  'Inserez le maillage interne': 'Vložte interní propojení',
  'Merci de vous assurer que la densité des mots clés soit optimisée pour le SEO (une occurrence maximum tous les 50 mots).\nSi vous constatez un terme pouvant avoir plusieurs significations (Exemple : Former / Formation/ Forme ou Matelas/Matelassé) , vous pouvez faire une demande d’examen auprès du support.':
    'Ujistěte se, že hustota klíčových slov je optimalizována pro SEO (maximálně jedna výskyt každých 50 slov).\nPokud narazíte na termín, který může mít více významů (Příklad: Forma / Formace / Tvar nebo Matrace / Vyšívaná), můžete požádat o přezkum u podpory.',
  'Mots clés à haute densité dans le texte actuel':
    'Klíčová slova s vysokou hustotou v aktuálním textu',
  'Mots clés à haute densité dans le texte initial':
    'Klíčová slova s vysokou hustotou v původním textu',
  'Texte en cours de rédaction !': 'Text se píše !',
  'Êtes-vous sûr(e) de vouloir valider le texte ? Assurez-vous d’abord d’avoir enregistré les modifications.':
    'Jste si jistý/á, že chcete potvrdit text? Nejprve se ujistěte, že jste uložil(a) změny.',
  "Information dernière minute ! Ton stock de crédits sera bientôt épuisé :( Pour anticiper, n'hésite pas à demander dès maintenant plus de crédits pour terminer ta commande.":
    'Poslední informace! Tvůj kreditní zásobník brzy dojde :( Pro předběžnou přípravu neváhej teď požádat o více kreditů k dokončení objednávky.',
  'Voulez-vous confirmer l’URL actuelle ou la modifier ?':
    'Chcete potvrdit aktuální URL nebo ji změnit?',
  'Veuillez fournir une URL valide': 'Prosím, zadejte platnou URL adresu.',
  'Merci de bien vouloir indiquer ci-dessous l’url de la page où a été intégré le contenu:':
    'Děkujeme, že uvedete níže URL adresu stránky, kde byl obsah integrován:',
  'Contenu en ligne': 'Obsah online',
  'Télécharger le document de révision': 'Stáhnout revizní dokument',
  'Date d’envoi': 'Datum odeslání',
  Information: 'Informace',
  Enregistrer: 'Uložit',
  'Textes en ligne': 'Texty online,',
  'Livrer les textes': 'Doručit texty',
  Indisponible: 'Nedostupné',
  Disponible: 'Dostupné',
  'Les textes ont été livrés avec succès.': 'Texty byly úspěšně doručeny.',
  'Le texte a été livré avec succès.': 'Text byl úspěšně doručen.',
  'Les textes ont été validés avec succès.': 'Texty byly úspěšně ověřeny.',
  'Le texte a été validé avec succès.': 'Text byl úspěšně ověřen.',
  'Voulez-vous vraiment valider les Textes de la commande':
    'Opravdu chcete ověřit texty objednávky?',
  'Voulez-vous vraiment livrer les Textes de la commande':
    'Opravdu chcete doručit texty objednávky?',
  'Fiche produit longue': 'Dlouhý produktový list',
  'Fiche produit courte': 'Krátký produktový list',
  'Un texte est trop long et ne peut pas être exporté sur Excel':
    'Text je příliš dlouhý a nelze jej exportovat do Excelu.',
  'Mettre un texte en brouillon en livré':
    'Převést text z konceptu na doručený',
  'Remettre un texte validé à livré': 'Převést ověřený text na doručený',
  'Invalider le texte': 'Zneplatnit text',
  'Je souhaiterai modifier mon mot de passe : comment faire ?':
    'Chtěl(a) bych změnit své heslo: jak na to?',
  'Comment mettre un contenu en bon pour livraison ?':
    'Jak nastavit obsah pro dodání?',
  'Je ne peux pas mettre mon contenu en « brouillon »':
    'Nemohu uložit svůj obsah jako „koncept“',
  'Typix n’a pas enregistré mes dernières modifications':
    'Typix neuložil mé poslední změny',
  'Comment rédiger une création de contenu ?': 'Jak napsat tvorbu obsahu?',
  'Comment rédiger une optimisation de contenu ?':
    'Jak napsat optimalizaci obsahu?',
  'Je ne vois plus ma commande – que faire ?':
    'Nevidím svou objednávku – co dělat?',
  'Comment générer une facture ?': 'Jak vytvořit fakturu?',
  'Je ne peux pas generer ma facture : que faire ?':
    'Nemohu vytvořit fakturu: co dělat?',
  'Tuto process Typix global': 'Globální proces Typix - tutoriál',
  'Tuto mise en ligne des contenus': 'Jak nahrát obsah - tutoriál',
  'Modification mot de passe': 'Změna hesla',
  'Le test ne me convient pas': 'Test mi nevyhovuje',
  'Comment valider un contenu dans Typix ?': 'Jak schválit obsah v Typixu?',
  'Tuto Facturation': 'Tutoriál fakturace',
  'Le statut du contenu a bien été modifié': 'Stav obsahu byl úspěšně změněn',
  'Le gap sémantique de ce mot clé n’a pas encore été validé, veuillez contacter le support Typix : support-typix@pixalione.com':
    'Sémantická mezera tohoto klíčového slova ještě nebyla ověřena, kontaktujte prosím podporu Typix: support-typix@pixalione.com',
  'Ce mot clé n’existe pas sur MONETORING, veuillez vérifier avec le support Typix : support-typix@pixalione.com':
    'Toto klíčové slovo neexistuje na MONETORING, zkontrolujte prosím s podporou Typix: support-typix@pixalione.com',
  'Récupérer le Gap': 'Získat mezeru',
  'Le statut du contenu a bien été modifié': 'Stav obsahu byl úspěšně změněn',
  'Le gap sémantique de ce mot clé n’a pas encore été validé, veuillez contacter le support Typix : support-typix@pixalione.com':
    'Sémantická mezera tohoto klíčového slova ještě nebyla ověřena, kontaktujte prosím podporu Typix: support-typix@pixalione.com',
  'Ce mot clé n’existe pas sur MONETORING, veuillez vérifier avec le support Typix : support-typix@pixalione.com':
    'Toto klíčové slovo neexistuje na MONETORING, zkontrolujte prosím s podporou Typix: support-typix@pixalione.com',
  'Récupérer le Gap': 'Získat mezeru',
  'Rédaction et/ou Traduction premium': 'Prémiové psaní a/nebo překlad',
  'Rédaction et/ou Traduction avec révision': 'Psaní a/nebo překlad s revizí',
  'Rédaction et/ou Traduction intelligente':
    'Inteligentní psaní a/nebo překlad',
  'Traduction avec révision': 'Překlad s revizí',
  'Traduction intelligente': 'Inteligentní překlad',
  'Le nombre de mots commandé est supérieur à celui vendu':
    'Počet objednaných slov je vyšší než prodaný',
  'Rédaction et/ou Traduction premium': 'Prémiové psaní a/nebo překlad',
  'Rédaction et/ou Traduction smart + review':
    'Inteligentní psaní a/nebo překlad + revize',
  'Rédaction et/ou Traduction smart': 'Inteligentní psaní a/nebo překlad',
  'Nom Silo': 'Název Silo',
  'Remettre en brouillon': 'Vrátit do konceptu',
  'Bon pour Livraison Vérifié': 'Potvrzeno pro doručení',
  'Voulez-vous vraiment remettre en brouillon les Textes de la commande':
    'Opravdu chcete vrátit texty objednávky do konceptu',
  'La vérification du texte a été annulée.': 'Ověření textu bylo zrušeno.',
  'Voulez-vous vraiment annuler la vérification du texte?':
    'Opravdu chcete zrušit ověření textu?',
  'Etes-vous sûr(e) de vouloir regénérer tous les contenus ?':
    'Jste si jistý/á, že chcete znovu vygenerovat veškerý obsah?',
  'Je suis sûr(e)': 'Jsem si jistý/á',
  'Non, revenir en arrière': 'Ne, vrátit se zpět',
  'à cocher si la commande a l’intention d’avoir un rédacteur exclusif pour le client':
    'zaškrtnout, pokud má objednávka v úmyslu mít exkluzivního redaktora pro klienta',
  Gouvernance: 'Řízení',
  Rédacteur: 'Redaktor',
  'Modification à valider': 'Změna ke schválení',
  'Nouveau site web': 'Nová webová stránka',
  'Mail Chef Project': 'E-mail vedoucího projektu',
  'Site web': 'Webová stránka',
  'Liste des siteweb': 'Seznam webových stránek',
  'Projets non attribuées': 'Nepřiřazené projekty',
  'Projets en cours': 'Probíhající projekty',
  'Projets en retard': 'Zpožděné projekty',
  'Projets validées': 'Ověřené projekty',
  'Projets smart + reviews': 'Smart + review projekty',
  'Projets smart': 'Smart projekty',
  'Ajouter un siteweb': 'Přidat webovou stránku',
  'Nouveau projet': 'nový projekt',
  Éditer: 'Upravit',
  Vous: 'Your website',
  'Comparaison du score global': 'Comparison of global score',
  'avec le top 3 concurrents': 'with top 3 competitors',
  'Position du mot clé avec le top 3 concurrents': 'Keyword ranking',
  Balises: 'Štítky',
  Lisibilité: 'Čitelnost',
  'Longueur des paragraphes': 'Délka odstavců',
  Phrases: 'Věty',
  'de +100 mots sur': 'více než +100 slov v',
  Phrase: 'Věta',
  'de +20 mots sur': 'více než +20 slov v',
  'Notre recommandation': 'Naše doporučení',
  'Longueur du texte': 'Délka textu',
  'Formats de contenus variés': 'Různé formáty obsahu',
  'par rapport au top 3 de vos concurrents': 've srovnání s top 3 vašimi konkurenty',
  'Vous êtes': 'Jste',
  'Vous avez un score global de': 'Máte celkové skóre',
  'pour une moyenne du secteur à': 'pro průměr odvětví',
  'GAP comblé - Mission accomplie': 'Mezera uzavřena – Mise splněna',
  'Mots clé restants': 'Zbývající klíčová slova',
  'Phrases de +20 mots': 'Věty s více než 20 slovy',
  'Titre H1': 'Titulek H1',
  'Titres H2': 'Titulek H2',
  'Dans le texte actuel': 'V aktuálním textu',
  'Dans le texte initial': 'V původním textu',
  mots: 'slova',
  objectif: 'Cíl',
  phrase: 'Věta',
  paragraphe: 'Odstavec',
  'Temps de lecture': 'Doba čtení',
  'requis ( Bullet point, Bon à savoir,Sommaire)': 'Požadováno (odrážky, dobré vědět, souhrn)',
  'de contenu sur': 'Množství obsahu na',
  'Félicitations ! Le nombre de mots correspond à la quantité d’informations importantes permettant de répondre au sujet': 'Gratulujeme! Počet slov odpovídá množství důležitých informací k tématu.',
  'Félicitations ! Votre contenu ne contient aucune phrase de plus de 20 mots !': 'Gratulujeme! Váš obsah neobsahuje žádnou větu delší než 20 slov!',
  'Félicitations ! Votre contenu est aéré et facilite la lecture': 'Gratulujeme! Váš obsah je přehledný a usnadňuje čtení.',
  'Félicitations ! Votre contenu dispose de formats variés qui dynamisent la lecture et permettent d’isoler les informations importantes.': 'Gratulujeme! Váš obsah používá různé formáty, které zlepšují čtení a zvýrazňují důležité informace.',
  'Félicitations ! Le contenu présente une balise h1 unique et contient le mot clé à l’origine du texte': 'Gratulujeme! Obsah obsahuje unikátní H1 a zahrnuje hlavní klíčové slovo.',
  'Félicitations ! Le contenu est structuré de façon cohérente et présente au moins 2 balises <h2>': 'Gratulujeme! Obsah je strukturován konzistentně a obsahuje alespoň 2 H2 tagy.',
  'Félicitations ! Votre contenu contient du maillage interne pondéré et qui ne pollue pas la lecture.': 'Gratulujeme! Váš obsah obsahuje vyvážené interní odkazy, které nenarušují čtení.',
  'Félicitations ! Le scoring d’enrichissement est supérieur à 85%!': 'Gratulujeme! Skóre obohacení je vyšší než 85 %!',
  'Félicitations ! Votre texte n’est pas suroptimisé sur le mot clé ciblé.': 'Gratulujeme! Váš text není přehnaně optimalizován pro cílové klíčové slovo.',
  'Le nombre de mots doit correspondre à la quantité d’informations importantes permettant de répondre au sujet': 'Počet slov musí odpovídat množství důležitých informací k tématu.',
  'Il est important d’adapter le niveau de vocabulaire en fonction de votre cible. Un vocabulaire simple pourrait l’infantiliser et, à l’inverse, un vocabulaire trop complexe pourrait rendre le contenu inaccessible.': 'Je důležité přizpůsobit slovník cílové skupině. Příliš jednoduchý jazyk působí infantilně, příliš složitý může obsah zpřístupnit těžko.',
  'Plus de 70% des internautes ne lisent pas les phrases > 20 mots => Utiliser des phrases concises pour augmenter le temps de rétention sur la page': 'Více než 70 % uživatelů nečte věty delší než 20 slov → používejte stručné věty pro delší dobu setrvání na stránce.',
  "Un contenu constitué de blocs de paragraphes trop compact va altérer l'UX et augmenter le taux de rebond.": 'Obsah tvořený příliš kompaktními odstavci zhoršuje UX a zvyšuje míru opuštění.',
  "Multipliez les différents formats d'affichage pour une lecture plus lisible et confortable.": 'Používejte různé formáty pro snazší a pohodlnější čtení.',
  'Un contenu optimisé doit obligatoirement contenir une seule balise h1 et mentionner le mot clé. ': 'Optimalizovaný obsah musí obsahovat pouze jeden H1 tag a zmínit klíčové slovo.',
  'Pour une structure de contenu optimale, il faut au moins 2 balises h2.': 'Pro optimální strukturu obsahu jsou potřeba alespoň 2 H2 tagy.',
  'Le maillage interne est un très bon moyen de connecter une page avec d’autres pages traitant du même sujet, ou complémentaires.': 'Interní propojení je skvělý způsob, jak propojit stránku s jinými souvisejícími nebo doplňujícími stránkami.',
  'Un contenu optimisé doit obtenir un scoring d’enrichissement de min 85%. Supprimer du gap sémantique altèrera le scoring d’optimisation': 'Optimalizovaný obsah by měl dosáhnout minimálně 85 % skóre obohacení. Odstranění sémantické hloubky sníží skóre.',
  'Répéter le mot trop de fois dans le contenu est pénalisant pour le moteur de recherche. Idéalement, ne pas dépasser un taux de 2.35% (soit environs 2 répétitions pour 100 mots). ': 'Opakování klíčového slova příliš často je penalizováno vyhledávači. Ideálně nepřekračujte 2,35 % (cca 2 opakování na 100 slov).',
  'Aucune balise H1 trouvée.': 'Nebyl nalezen žádný H1 tag.',
  'Balise H1 contient le mot-clé.': 'H1 tag obsahuje klíčové slovo.',
  'Balise H1 présente mais sans le mot-clé.': 'H1 tag je přítomen, ale neobsahuje klíčové slovo.',
  '{{count_total}} balises H2 trouvées, {{count_with_kw}} avec mot-clé.': '{{count_total}} H2 tagy nalezeny, {{count_with_kw}} s klíčovým slovem.',
  ' balises H2 trouvées,': ' H2 tagy nalezeny,',
  ' avec mot-clé.': ' s klíčovým slovem.',
  'Très facile à lire : Accessible aux enfants ou à des personnes avec un niveau de lecture basique.': 'Velmi snadné čtení: přístupné pro děti nebo osoby se základní úrovní čtení.',
  'Facile à lire : Compréhensible par la majorité des adultes et adolescents.': 'Snadné čtení: srozumitelné pro většinu dospělých a dospívajících.',
  'Difficile à lire : Nécessite un bon niveau de lecture, parfois un bagage académique': 'Obtížné čtení: vyžaduje dobré čtenářské dovednosti, někdy akademické vzdělání.',
  'Très difficile à lire : Réservé à un public expert ou très averti': 'Velmi obtížné čtení: určeno odborné nebo velmi zkušené veřejnosti.',
  'Wording adapté': 'Přizpůsobená slovní zásoba',
  "La balise H1 est essentielle pour l'optimisation SEO.": 'H1 tag je zásadní pro SEO optimalizaci.',
  'Une seule balise H1 avec le mot-clé est recommandée.': 'Doporučuje se pouze jeden H1 tag s klíčovým slovem.',
  'Ajoutez le mot-clé dans la balise H1.': 'Přidejte klíčové slovo do H1 tagu.',
  'Adaptez votre vocabulaire à votre audience. Trop simple infantilise, trop complexe exclut.': 'Přizpůsobte slovník publiku. Příliš jednoduchý infantilizuje, příliš složitý vylučuje.',
  'Les contenus web se lisent rapidement. Un temps trop long peut décourager.': 'Webový obsah se čte rychle. Příliš dlouhá doba čtení může odradit.',
  'Information sur la structure': 'Informace o struktuře',
  'Information sur le résultat sémantique': 'Informace o sémantickém výsledku',
  'Information sur les balises HTML': 'Informace o HTML tagách',
  'Information sur le keyword stuffing': 'Informace o keyword stuffingu',

  ////////
  'Derniers contenus rédigés': 'Nejnovější vytvořený obsah',
  'voir plus': 'Zobrazit více',
  'texte': 'Text',
  'date d\'ajout': 'Datum přidání',
  'titre du projet': 'Název projektu',
  'Date de création': 'Datum vytvoření',
  'dernières projets créés': 'Nejnovější vytvořené projekty',
  '% projets par statut de validation :': '% projektů podle stavu schválení:',
  'non attribués': 'Nepřiřazeno',
  'en cours': 'Probíhá',
  'en retard': 'Zpožděné',
  'validées': 'Schváleno',
  'smart + reviews': 'Smart + Hodnocení',
  'smart': 'Smart',
  'premium': 'Premium',
  'smart + review': 'Smart + Recenze',
  'Statut d\'avancement des contenus:': 'Stav pokroku obsahu:',
  'Nombre de textes publiés :': 'Počet publikovaných textů:',
  'Nb de textes publiés': 'Počet publikovaných textů',
  'Top ranked': 'Nejlépe hodnocené',
  'Mot clé': 'Klíčové slovo',
  'Clicks': 'Kliky',
  'Clicks (Y-1)': 'Kliky (Y-1)',
  'Position': 'Pozice',
  'Sessions': 'Sezení',
  'Sessions (Y-1)': 'Sezení (Y-1)',
  'Evolution performance': 'Vývoj výkonu',
  'Pourcentage': 'Procento',
  'Livré': 'Doručeno',
  'Publié': 'Publikováno',
  'Suivez vos contenus et projets en temps réel': 'Sledujte svůj obsah a projekty v reálném čase',
  'Tableau de bord': 'Řídicí panel',
  'Titre du projet': 'Název projektu',
  'Conversions': 'Konverze',
  'Impressions': 'Zobrazení',
  'Jan': 'Led',
  'Fév': 'Ún',
  'Mars': 'Bře',
  'Avr': 'Dub',
  'Mai': 'Kvě',
  'Juin': 'Čvn',
  'Juil.': 'Čvc',
  'Août': 'Srp',
  'Sept': 'Zář',
  'Oct': 'Říj',
  'Nov': 'Lis',
  'Déc': 'Pro',
  'Pour activer cette fonctionnalité, ajoutez notre adresse ': 'Chcete-li tuto funkci aktivovat, přidejte naši adresu ',
  'à votre ': ' do vašeho ',
  'Search Console': 'Search Console',
  ', ': ', ',
  'puis cliquez ici pour lancer l’analyse.': 'poté klikněte zde pro spuštění analýzy.',
  'all devices': 'Všechna zařízení',
  'Desktop': 'Počítač',
  'Mobile': 'Mobil',
  '30 days': '30 dní',
  '7 days': '7 dní',
  '90 days': '90 dní',
  'Aucun projet créé pour le moment.': 'Žádné projekty zatím nebyly vytvořeny.',
  'Lancer votre premier projet': 'Spusťte svůj první projekt',
  'Aucun contenu disponible pour ce site web.': 'Pro tento web není dostupný žádný obsah.',
  'Mes contenus': 'Můj obsah',
  'Type de contenu': 'Typ obsahu',
  'Date d\'ajout': 'Datum přidání',
  'URL': 'URL',
  'Status': 'Stav',
  'Date de livraison': 'Datum doručení',
  'Date de validation': 'Datum schválení',
  'Date de déploiement': 'Datum nasazení',
  'Action': 'Akce',
  'Aucun contenu pour ce filtre.': 'Žádný obsah pro tento filtr.',
  'Chargement...': 'Načítání...',
  'Aucun contenu.': 'Žádný obsah.',
  'Précédent': 'Předchozí',
  'Suivant': 'Další',
  'fiche produit': 'Produktový list',
  'Page catégorie': 'Kategorie stránky',
  'Fiche GMB': 'GMB stránka',
  'store locator': 'Vyhledávač obchodů',
  'redaction': 'Redakce',
  'traduction': 'Překlad',
  'Fiches produit SEO': 'SEO produktové listy',
  'Derniers projets crées': 'Nejnovější vytvořené projekty',
  'Agent IA': 'AI agent',
  'Dérniére mise à jour': 'Poslední aktualizace',
  'Créer un nouveau contenu': 'Vytvořit nový obsah',
  'Rédigez un texte optimisé grâce à l’IA — rapide, pertinent et performant.': 'Napište text optimalizovaný pomocí AI – rychlý, relevantní a efektivní.',
  'Validé': 'Schváleno',
  'En ligne': 'Online',
  'Fiches GMB': 'GMB stránky',
  'Fiches store locator': 'Stránky vyhledávače obchodů',
  'Pages catégories': 'Kategorie stránek',
  'Traduction IA': 'AI překlad',
  'Actions': 'Akce',
  'Traduire un nouveau contenu': 'Přeložit nový obsah',
  'Traduisez vos contenus automatiquement avec une précision multilingue.': 'Automaticky přeložte svůj obsah s přesností více jazyků.',
  'Nom du projet': 'Název projektu',
  'Chef de projet': 'Projektový manažer',
  'Deadline du projet': 'Termín projektu',
  'Informations globales': 'Obecné informace',
  'Contenu du projet': 'Obsah projektu',
  'Séléctionner le type de contenu': 'Vyberte typ obsahu',
  'Sélectionner un agent IA personnalisé': 'Vyberte vlastního AI agenta',
  'Créer un agent IA personnalisé': 'Vytvořit vlastního AI agenta',
  'Liens utiles': 'Užitečné odkazy',
  'Rédacteur(s)': 'Autor(i)',
  'Deadline': 'Termín',
  'Nb textes': 'Počet textů',
  'IA + Revue par rédacteur': 'AI + Kontrola autorem',
  'Ajouter un projet': 'Přidat projekt',
  'Projets': 'Projekty',
  'Non attribués': 'Nepřiřazeno',
  'Rédaction IA': 'AI psaní',
  'Résultats sur': 'Výsledky na',
  'Êtes-vous sûr de vouloir supprimer cet agent IA ?': 'Opravdu chcete odstranit tohoto AI agenta?',
  'Mes agents IA': 'Moji AI agenti',
  'Tous': 'Vše',
  'Rédaction': 'Redakce',
  'Traduction': 'Překlad',
  'Rechercher': 'Hledat',
  'Sélectionner un site': 'Vyberte web',
  'Créer un agent IA personnalisé': 'Vytvořit vlastního AI agenta',
  'Définissez la mission, le rôle, la langue, le type de contenu et plus encore.': 'Definujte úkol, roli, jazyk, typ obsahu a další.',
  'Nouvel agent': 'Nový agent',
  'Rôle :': 'Role:',
  'Type de contenu :': 'Typ obsahu:',
  'Langue :': 'Jazyk:',
  'Siteweb :': 'Webová stránka:',
  'GBP': 'GBP',
  'Sélectionner un LLM': 'Vyberte LLM',
  'Fiche produit smart': 'Smart produktový list',
  'Détails du texte': 'Detaily textu',
  '(Mot clé*, URL, Balise titre, Balise méta-description)': '(Klíčové slovo*, URL, Titulek, Meta popis)',
  'URL siteweb*': 'URL webu*',
  'Balise titre': 'Titulek',
  'Balise méta-description': 'Meta popis',
  'Sélectionner un site web': 'Vyberte web',
  'Sélectionner un agent IA': 'Vyberte AI agenta',
  'Lancer': 'Spustit',
  'Relancer': 'Spustit znovu',
  'Génération en cours...': 'Generování probíhá...',
  'Générer': 'Generovat',
  'Enregistrement...': 'Ukládání...',
  'Enregistrer ': 'Uložit',
  'Livrer': 'Doručit',
  'Livraison...': 'Doručování...',
  'En ligne...': 'Online...',
  "Derniers contenus ajoutés": "Nejnovější přidaný obsah",
  /////
  'Nom de l\'agent': 'Jméno agenta',
  'Site web': 'Webová stránka',
  'Mission': 'Mise',
  'Langue de traduction': 'Jazyk překladu',
  'Langue': 'Jazyk',
  'Tonalité': 'Tón',
  'Cible / Audience': 'Cílové publikum',
  'Base de connaissance locale': 'Místní znalostní báze',
  'Base de connaissance en ligne': 'Online znalostní báze',
  'Sélect. fichiers': 'Vybrat soubory',
  'Ex: URL1, URL2': 'Příklad: URL1, URL2',
  'Annuler': 'Zrušit',
  'Mettre à jour': 'Aktualizovat',
  'Valider': 'Potvrdit',
  'Ex: un paragraphe sur les types d\'intervention, un paragraphe sur les avantages': 'Např.: odstavec o typech zásahů, odstavec o výhodách',
  'ex : les parapluies pliant sont à ouverture automatique, les autres sont manuels': 'Např.: skládací deštníky se otevírají automaticky, ostatní jsou manuální',
  '📚 Base de connaissances': '📚 Znalostní báze',

  'Type de produits / services proposés par le site*': 'Typy produktů / služeb nabízených webem*',
  'Règles rédactionnelles': 'Redakční pravidla',
  'Lexique recommandé': 'Doporučený slovník',
  'Expressions interdites': 'Zakázané výrazy',
  'Instructions de personnalisation': 'Pokyny k personalizaci',

  "🧩 Informations générales": "🧩 Obecné informace",
  "🗣️ Ton & Audience": "🗣️ Tón a publikum",
  "📝 Structure & Rédaction": "📝 Struktura a psaní",
  "📚 Base de connaissances": "📚 Znalostní báze",
  "Structure de texte attendu": "Očekávaná textová struktura",
  "Enrichissement SEO": "SEO obohacení",
  "traduction IA": "Překlad pomocí AI",
  "Traduction en cours...": "Probíhá překlad...",
  "Traduire": "Přeložit",
  "Créer votre assistant éditorial sur mesure": "Vytvořte si vlastní redakčního asistenta",
  "Votre texte traduit": "Váš přeložený text",
  "Détail du projet": "Detail projektu",
  "Détail d'attribution": "Detail přiřazení",
  "Détail des contenus": "Detail obsahu",

  // -----
  "Nom agent": "Jméno agenta",
  "Rédaction": "Tvorba obsahu",
  "Traduction": "Překlad",
  "Mots clé": "Klíčová slova",
  "Url de la page": "URL stránky",
  "Entrez le mot clé principal": "Zadejte hlavní klíčové slovo",
  "Entrez l url": "Zadejte URL",
  "Date d'ajout": "Datum přidání",
  "Dernière mise à jour": "Poslední aktualizace",
  "URL": "URL",
  "Status": "Stav",
  "Actions": "Akce",
  "Détails du texte": "Detail textu",
  "Contenus disponibles": "Dostupný obsah",
  "Textes générés": "Vygenerované texty",

  "Veuillez d'abord sélectionner un site web": "Nejprve vyberte webovou stránku",
  "Chargement des agents...": "Načítání agentů...",
  "Aucun agent disponible pour ce site": "Pro tuto stránku nejsou k dispozici žádní agenti",
  "Sélectionner...": "Vybrat...",
  "Modifier cet agent": "Upravit tohoto agenta",
  "Créer un agent IA personnalisé": "Vytvořit vlastního AI agenta",
  "Rédaction en cours...": "Probíhá tvorba obsahu...",
  "Génération en cours": "Probíhá generování",
  "Rédiger un contenu": "Vytvořit obsah",
  "Rédiger un lot de contenus": "Vytvořit více obsahů",
  "Url page": "URL stránky",
  "Entrez l'URL cible de votre contenu (facultatif).": "Zadejte cílovou URL vašeho obsahu (volitelné).",
  "GAP sémantique": "Sémantická mezera",
  "keyword1 (2),\nkeyword2 (1),\nkeyword3 (1),\nkeyword4 (2),\n.....": "keyword1 (2),\nkeyword2 (1),\nkeyword3 (1),\nkeyword4 (2),\n.....",
  "Maillage interne": "Vnitřní propojení",
  "Introduisez le maillage": "Zadejte propojení",
  "Introduisez le maillage interne": "Zadejte vnitřní propojení",
  "Importer un fichier contenant la liste des thématiques à rédiger et l'IA fera le reste 😊": "Importujte soubor s tématy k napsání a AI udělá zbytek 😊",
  "Importer": "Importovat",
  "Saisissez le mot-clé principal de votre contenu.": "Zadejte hlavní klíčové slovo vašeho obsahu.",
  "Texte à traduire": "Text k překladu",
  "Saisissez le texte à traduire": "Zadejte text k překladu",
  "Traduire un contenu": "Přeložit obsah",
  "Traduire un lot de contenus": "Přeložit více obsahů",
  "Importer un fichier contenant la liste des textes à traduire et l'IA fera le reste 😊": "Importujte soubor s texty k překladu a AI udělá zbytek 😊",
  "Commencer la traduction": "Spustit překlad",
  "Lancer la traduction": "Spustit překlad",
  "Commencer la rédaction": "Spustit tvorbu obsahu",
  "Lancer la rédaction": "Spustit tvorbu obsahu",


  'En ligne...': 'Online...',
  'Ajouter un nouveau site web': 'Přidat nový web',
  'Créer': 'Vytvořit',
  'Séléctionner ou ajoutez les thématiques qui reflètent votre expertise.': 'Vyberte nebo přidejte témata, která odrážejí vaši odbornost.',
  'Ajoutez ou sélectionnez une thématique': 'Přidejte nebo vyberte téma.',
  'Le site web a été créé avec succès': 'Web byl úspěšně vytvořen',
  'Nous configurons actuellement vos agents IA. Ils seront bientôt prêts à vous assister dans la génération de vos contenus.': 'Právě konfigurujeme vaše AI agenty. Brzy budou připraveni pomoci vám při tvorbě obsahu.',
  'Derniers contenus ajoutés': 'Poslední přidaný obsah',
  'Tous les sites': 'Všechny weby',
  'Sélectionner le site web': 'Vyberte web',
  'Aucun fichier sélectionné': 'Nebyl vybrán žádný soubor',
  'ex : utilise le vouvoiement, utilise un vocabulaire compréhensible par la cible': 'Např.: používejte vykání a slovní zásobu srozumitelnou pro cílovou skupinu.',
  '🧠 Créer un agent IA': '🧠 Vytvořit AI agenta',
  '🧠 Modifier un agent IA': '🧠 Upravit AI agenta',
  'Ex : AMF (Autorité des Marchés Financiers).': 'Např.: AMF (Autorita finančních trhů).',
  'Ex: bio, écologique, nom des concurrents': 'Např.: bio, ekologické, názvy konkurentů.',
  'Détailler le plus possible la structure attendue à l\'aide d\'axes de rédaction pour guider l\'IA sur les sujets à traiter et dans quel ordre': 'Popište co nejpodrobněji očekávanou strukturu, aby měla AI jasné pokyny ohledně témat a jejich pořadí.',
  'Ajouter des éléments que l\'IA doit ou ne pas faire ou mentionner': 'Přidejte prvky, které má nebo nemá AI dělat či zmiňovat.',
  'Ex: prêt-à-porter féminin': 'Např.: digitální marketing',
  'Ex: Rédacteur SEO': 'Např.: SEO copywriter',
  'Indiquer la liste des urls sur lesquels l\'IA peut s\'appuyer': 'Uveďte seznam URL, o které se může AI opírat.',
  'Créez, optimisez, performez : votre contenu prend une nouvelle dimension.': 'Vytvářejte, optimalizujte, dosahujte výsledků: váš obsah získává nový rozměr.',
  'La création de contenu n\'a jamais été aussi smart.': 'Tvorba obsahu nikdy nebyla tak chytrá.',
  'Boostez votre productivité grâce à la puissance multi-IA. Comparez et combinez les meilleures propositions issues de plusieurs LLM, puis optimisez-les grâce à un score de contenu en temps réel (SEO, lisibilité, pertinence)': 'Zvyšte svou produktivitu díky síle multi-AI. Porovnávejte a kombinujte nejlepší návrhy z různých LLM a optimalizujte je díky skóre obsahu v reálném čase (SEO, čitelnost, relevance).',
  'Je crée mon premier contenu SEO friendly': 'Vytvářím svůj první SEO optimalizovaný obsah.',
  'Veuillez coller le texte source....': 'Vložte prosím zdrojový text, který chcete přeložit…',
  'Enrichir': 'Spustit',
  'Veuillez d\'abord sélectionner un site web': 'Nejprve prosím vyberte web',
  "🎯 Commencez ici": "🎯 Začněte zde",
  "Ajoutez ou sélectionnez le site web que vous souhaitez suivre.": "Přidejte nebo vyberte web, který chcete sledovat.",
  "📝 Derniers contenus créés": "📝 Poslední vytvořený obsah",
  "Retrouvez ici les derniers contenus créés pour le site sélectionné.": "Zde najdete poslední obsah vytvořený pro vybraný web.",
  "Cliquez sur un texte pour consulter sa fiche détaillée.": "Klikněte na text pro zobrazení jeho detailů.",
  "📁 Derniers projets créés": "📁 Poslední vytvořené projekty",
  "Accédez rapidement aux derniers projets lancés pour ce site.": "Rychle přistupte k posledním projektům spuštěným pro tento web.",
  "Cliquez sur un projet pour voir son avancement et les contenus associés.": "Klikněte na projekt pro zobrazení jeho postupu a souvisejícího obsahu.",
  "📊 Suivi de vos projets": "📊 Sledování vašich projektů",
  "Visualisez la répartition de vos projets : en cours, en retard ou validés.": "Zobrazte si rozložení projektů: probíhající, zpožděné nebo dokončené.",
  "Une vue d’ensemble claire pour suivre l’état global de votre production.": "Jasný přehled o celkovém stavu vaší produkce.",
  "📑 Statut d’avancement des contenus": "📑 Stav pokroku obsahu",
  "Suivez ici la répartition de vos contenus : brouillons, livrés et publiés.": "Sledujte zde rozložení vašeho obsahu: koncepty, odevzdané a publikované.",
  "Idéal pour identifier rapidement où concentrer vos efforts.": "Ideální pro rychlé zjištění, kam soustředit své úsilí.",
  "📅 Textes publiés par mois": "📅 Publikované texty podle měsíců",
  "Visualisez le nombre de textes publiés chaque mois pour le site sélectionné.": "Zobrazte počet textů publikovaných každý měsíc pro vybraný web.",
  "Suivez ainsi votre rythme de déploiement dans le temps.": "Sledujte tak svůj publikační rytmus v čase.",
  "⭐ Top mots-clés": "⭐ Top klíčová slova",
  "Découvrez vos 5 mots-clés les plus performants issus de la Search Console.": "Objevte svých 5 nejvýkonnějších klíčových slov ze Search Console.",
  "Comparez leur position, les clics actuels et les clics de l’année précédente.": "Porovnejte jejich pozici, aktuální kliknutí a kliknutí z předchozího roku.",
  "📈 Activer le suivi du trafic": "📈 Aktivovat sledování návštěvnosti",
  "Ajoutez notre adresse e-mail à votre Search Console pour activer cette analyse.": "Přidejte naši e-mailovou adresu do své Search Console pro aktivaci této analýzy.",
  "Vous pourrez ensuite suivre l’évolution de votre trafic directement dans Typix.": "Poté můžete sledovat vývoj návštěvnosti přímo v Typixu.",
  "🏠 Tableau de bord": "🏠 Dashboard",
  "Revenez à la vue globale : indicateurs clés, contenus récents, projets et performances de votre site.": "Vraťte se do celkového zobrazení: klíčové ukazatele, poslední obsah, projekty a výkonnost vašeho webu.",
  "🤖 Agents IA": "🤖 AI agenti",
  "Configurez et pilotez vos agents IA pour automatiser la rédaction ainsi que la traduction et gagner du temps sur vos contenus.": "Nakonfigurujte a řiďte své AI agenty pro automatizaci psaní a překladu a ušetřete čas při práci s obsahem.",
  "✍️ Rédaction IA": "✍️ AI psaní",
  "Accédez aux générateurs IA : fiches produit, fiches GMB, pages catégories et autres contenus optimisés.": "Přistupte k AI generátorům: produktové stránky, GMB stránky, kategorie a další optimalizovaný obsah.",
  "🌍 Traduction IA": "🌍 AI překlad",
  "Traduisez vos contenus en plusieurs langues en quelques clics tout en conservant la cohérence SEO.": "Překládejte svůj obsah do více jazyků několika kliknutími při zachování SEO konzistence.",
  "➕ Créer un projet": "➕ Vytvořit projekt",
  "Lancez un nouveau projet de contenus en quelques secondes et suivez ensuite son avancement.": "Spusťte nový obsahový projekt během několika sekund a sledujte jeho průběh.",
  "📂 Gestion des projets": "📂 Správa projektů",
  "Accédez à vos projets non attribués, en cours, en retard ou validés pour suivre leur progression.": "Přistupte k nepřiřazeným, probíhajícím, zpožděným nebo dokončeným projektům a sledujte jejich vývoj.",
  "👤 Mon profil": "👤 Můj profil",
  "Modifiez vos informations personnelles.": "Upravte své osobní údaje.",
  "🧑‍🤝‍🧑 Gestion des utilisateurs": "🧑‍🤝‍🧑 Správa uživatelů",
  "Invitez de nouveaux membres, gérez leurs droits et organisez vos équipes simplement.": "Pozvěte nové členy, spravujte jejich oprávnění a snadno organizujte své týmy.",
  "❓ Mon guide": "❓ Můj průvodce",
  "Relancez ce guide interactif à tout moment pour retrouver les principales fonctionnalités de Typix.": "Spusťte znovu tento interaktivní průvodce kdykoli a získejte přístup k hlavním funkcím Typixu.",
  'Mon guide': 'Můj průvodce',
  'Se déconnecter': 'Odhlásit se',
  "L'adresse email est obligatoire.": "E-mailová adresa je povinná.",
  "Le nom est obligatoire.": "Příjmení je povinné.",
  "Le prénom est obligatoire.": "Jméno je povinné.",
  "Le mot de passe est obligatoire.": "Heslo je povinné.",
  "La confirmation est obligatoire.": "Potvrzení je povinné.",
  "Les mots de passe ne correspondent pas.": "Hesla se neshodují.",
  "Récapitulatif": "Souhrn",
  "Quitter la création": "Ukončit vytváření",
  "Objectif du projet": "Cíl projektu",
  "Mode de production": "Režim výroby",
  "Répartition du travail": "Rozdělení práce",
  "Contexte éditorial": "Redakční kontext",
  "Rédaction": "Psaní",
  "Traduction": "Překlad",
  "Créer du contenu original": "Vytvořit originální obsah",
  "Traduire un contenu existant": "Přeložit existující obsah",
  "Identification du projet": "Identifikace projektu",
  "Nom du projet": "Název projektu",
  "Vous pourrez modifier le nom plus tard": "Název můžete později změnit",
  "URL du site": "URL webu",
  "Langue": "Jazyk",
  "Sélectionner une langue": "Vybrat jazyk",
  "Nombre de textes": "Počet textů",
  "12 textes disponibles": "12 dostupných textů",
  "Chef de projet": "Vedoucí projektu",
  "Aucun chef de projet assigné au siteweb": "K webu není přiřazen žádný vedoucí projektu",
  "Sélectionner un chef de projet": "Vybrat vedoucího projektu",
  "Date limite du projet": "Termín projektu",
  "Nombre d’images": "Počet Obrázků",
  "Sélectionner une date limite": "Vybrat termín",
  "Suivant": "Další",
  "Retour": "Zpět",
  "Définissez l'objectif et le cadre général de votre projet.": "Definujte cíl a obecný rámec vašeho projektu.",
  "IA": "AI",
  "Production généré par IA": "Výroba generovaná AI",
  "Rédacteur": "Redaktor",
  "Production Rédacteur par IA": "Výroba redaktora pomocí AI",
  "IA + revue humaine": "AI + lidská kontrola",
  "IA avec validation humaine.": "AI s lidským ověřením.",
  "Répartissez les textes de votre projet entre vous et d'éventuels rédacteurs.": "Rozdělte texty vašeho projektu mezi sebe a případné redaktory.",
  "L'attribution à un rédacteur est optionnelle.": "Přiřazení redaktorovi je volitelné.",
  "Agent IA": "AI agent",
  "Vous pourrez changer d'agent plus tard": "Agenta můžete později změnit",
  "Veuillez d'abord sélectionner un site web": "Nejprve vyberte web",
  "Sélectionnez le mode IA": "Vyberte režim AI",
  "Aucun agent disponible": "Žádný agent není k dispozici",
  "Sélectionner un agent IA": "Vybrat AI agenta",
  "Format du contenu": "Formát obsahu",
  "Sélectionner un format": "Vybrat formát",
  "Nombre de mots par texte": "Počet slov na text",
  "Format personnalisé": "Vlastní formát",
  "définir le nombre de mots": "definovat počet slov",
  "mots": "slova",
  "Options avancées": "Pokročilé možnosti",
  "Enrichissement du contenu": "Obohacení obsahu",
  "Génération Image": "Generování Obrázků",
  "Consomment des crédits supplémentaires": "Spotřebovávají další kredity",
  "IA augmentée par vos données": "AI rozšířená o vaše data",
  "Sélectionnez les personnes en charge de la relecture des contenus générés par l'IA et répartissez": "Vyberte osoby odpovědné za kontrolu obsahu generovaného AI a rozdělte",
  "les textes à valider.": "texty k ověření.",
  "Le relecteur peut apporter des corrections et ajustements ciblés dans la limite de mots définie,": "Kontrolor může provést opravy a cílené úpravy v rámci definovaného limitu slov,",
  "sans réécrire entièrement le contenu.": "aniž by celý obsah přepsal.",
  "Contexte éditorial & brief détaillé du projet": "Redakční kontext a podrobný brief projektu",
  "Ajouter des informations contextuelles pour guider et enrichir la production des contenus.": "Přidat kontextové informace pro vedení a obohacení výroby obsahu.",
  "Gap sémantique": "Sémantická mezera",
  "optionnel": "volitelné",
  "Brief détaillé": "Podrobný brief",
  "Lien drive...": "Odkaz na disk...",
  "Lancer le projet": "Spustit projekt",
  "Nom du projet existant": "Název projektu již existuje",
  "Un projet avec ce nom existe déjà dans votre espace.": "Projekt s tímto názvem již ve vašem prostoru existuje.",
  "Merci de choisir un nom différent pour continuer.": "Prosím zvolte jiný název pro pokračování.",
  "Erreur lors de la création du projet. Veuillez réessayer.": "Chyba při vytváření projektu. Zkuste to prosím znovu.",
  "Félicitations !": "Gratulujeme!",
  "Votre projet a été créé avec succès !": "Váš projekt byl úspěšně vytvořen!",
  "Voir le projet": "Zobrazit projekt",
  "Fermer": "Zavřít",
  "Paramètres du compte": "Nastavení účtu",
  "Site web": "Web",
  "Langue du site": "Jazyk webu",
  "textes": "texty",
  "Deadline": "Termín",
  "Type": "Typ",
  "Rédacteur": "Redaktor",
  "Moi (par défaut)": "Já (výchozí)",
  "Livraison le": "Dodání dne",
  "À venir": "Přijde",
  "Production généré par IA": "Výroba generovaná AI",
  "Agent": "Agent",
  "Format": "Formát",
  "Enrichissement du contenu activé": "Obohacení obsahu aktivováno",
  "Relecteur": "Kontrolor",
  "texte": "text",
  "Limite de modification": "Limit úprav",
  "Aucune attribution": "Žádné přiřazení",
  "Aucun élément ajouté": "Žádný prvek přidán",
  "janvier": "leden",
  "février": "únor",
  "mars": "březen",
  "avril": "duben",
  "mai": "květen",
  "juin": "červen",
  "juillet": "červenec",
  "août": "srpen",
  "septembre": "září",
  "octobre": "říjen",
  "novembre": "listopad",
  "décembre": "prosinec",
  "à": "až",
  "mots minimum": "slov minimum",
  "mots maximum": "slov maximum",
  "Status de validation des projets": "Stav validace projektů",
  "Statut d'avancement des contenus": "Stav pokroku obsahu:",
  "Total des contenus": "Celkový obsah:",
  "Non attribué": "Nepřiřazeno",
  "Évolution des performances": "Vývoj výkonnosti",
  "Position": "Pozice",
  "Nombre de textes publiés": "Počet publikovaných textů",
  "Espace de travail AI": "Pracovní prostor AI",
  "Mise à jour 1.2": "Aktualizace 1.2",
  "Découvrez les dernières fonctionnalités, optimisations et correctifs.": "Objevte nejnovější funkce, optimalizace a opravy.",
  "Projet créé": "Projekt vytvořen",
  "Votre projet a bien été créé.": "Váš projekt byl úspěšně vytvořen.",
  "Vous pouvez commencer à travailler dessus dès maintenant.": "Můžete na něm začít pracovat hned teď.",
  "Générez plusieurs textes en important un fichier Excel": "Vytvářejte více textů importováním souboru Excel",
  "Importez un fichier Excel contenant la liste des textes à générer.": "Importujte soubor Excel obsahující seznam textů k vytvoření.",
  "Sélectionnez le mode IA": "Vyberte režim AI",
  "Aucun agent disponible": "Žádný agent není k dispozici",
  "Sélectionner un agent IA": "Vybrat AI agenta",
  "Sélectionner un format": "Vybrat formát",
  "Veuillez d'abord sélectionner un site web": "Nejprve vyberte web",

  //
  'Nouveau contenu': 'Nový obsah',
  'Génération en cours...': 'Probíhá generování...',
  'Optimisation en cours...': 'Probíhá optimalizace...',
  'Traduction en cours...': 'Probíhá překlad...',
  'En lignes': 'Online',
  'filtres': 'filtry',
  'trier par': 'řadit podle',
  'Score décroissant': 'Skóre sestupně',
  'Score croissant': 'Skóre vzestupně',
  'Date de création': 'Datum vytvoření',
  'Date de mise à jour': 'Datum poslední aktualizace',
  'Date récente': 'Nejnovější',
  'Date ancienne': 'Nejstarší',
  'Mots clés': 'Klíčová slova',
  'Éditeur': 'Editor',
  'Créateur': 'Tvůrce',
  'Rédacteurs': 'Autoři',
  'Réinitialisé par défaut': 'Obnovit výchozí nastavení',
  'Mode de rédaction': 'Režim psaní',
  'Agent AI utilisé': 'Použitý AI agent',
  'Textes en brouillons': 'Koncepty',
  'Modèle': 'Model',
  'Paramètres du projet': 'Nastavení projektu',
  'Avancement': 'Stav',
  'Progression': 'Postup',
  'Aucun texte disponible': 'Žádný dostupný text',
  'Détails du projet': 'Detaily projektu',
  'Page {{current}} sur {{total}}': 'Strana {{current}} z {{total}}',
  'Moteur LLM': 'LLM engine',
  'Rédiger un contenu': 'Vytvořit obsah',
  'Traduire un contenu': 'Přeložit obsah',
  'Optimiser un contenu': 'Optimalizovat obsah',
  'Générer un contenu': 'Generovat obsah',

  'Créez un texte pour un mot-clé spécifique avec un formulaire guidé':
    'Vytvořte text pro konkrétní klíčové slovo pomocí řízeného formuláře',

  'Traduire un texte spécifique avec un formulaire guidé':
    'Přeložte konkrétní text pomocí řízeného formuláře',

  'Générez plusieurs textes en important un fichier Excel':
    'Generujte více textů importem souboru Excel',

  'Rédiger un lot de contenus': 'Vytvořit dávku obsahů',
  'Traduire un lot de contenus': 'Přeložit dávku obsahů',
  'Enrichir un contenu': 'Obohatit obsah',

  'Optimisez un texte spécifique avec un formulaire guidé':
    'Optimalizujte konkrétní text pomocí řízeného formuláře',

  'Nombre total de textes alloués au projet':
    'Celkový počet textů přidělených projektu',

  'Vous pourrez changer le format du contenu plus tard':
    'Formát obsahu můžete změnit později',

  'Saisissez chaque mot-clé suivi de sa fréquence entre parenthèses, puis appuyez sur Entrée. Exemple : chaussures(3)':
    'Zadejte každé klíčové slovo následované jeho frekvencí v závorkách a poté stiskněte Enter. Příklad: boty(3)',

  'Ex: voiture(5), électrique(3), autonomie(8)':
    'Např.: auto(5), elektrické(3), dojezd(8)',

  'URLs des pages à lier (séparées par des virgules)':
    'URL stránek k propojení (oddělené čárkami)',

  'Besoin d\'aide pour préparer votre fichier ?':
    'Potřebujete pomoc s přípravou souboru?',

  'Télécharger le modèle (Excel)':
    'Stáhnout šablonu (Excel)',

  'Déposez votre fichier ici':
    'Přetáhněte soubor sem',

  'Glissez-déposez votre fichier Excel':
    'Přetáhněte soubor Excel',

  'ou cliquez pour parcourir':
    'nebo klikněte pro výběr',

  'Formats acceptés : .xlsx, .xls (max 10 Mo)':
    'Podporované formáty: .xlsx, .xls (max 10 MB)',

  'Parcourir les fichiers':
    'Procházet soubory',

  'Ex: télépéage automatique':
    'Např.: automatické mýtné',

  'Générer le contenu': 'Generovat obsah',
  'Lancer la génération': 'Spustit generování',
  'Commencer la traduction': 'Zahájit překlad',
  'Lancer la traduction': 'Spustit překlad',

  'Partager': 'Sdílet',
  'Telecharger le texte': 'Stáhnout text',
  'Modifier le projet': 'Upravit projekt',
  'Modifiez les détails de votre projet ici.':
    'Upravte detaily svého projektu zde.',

  'Général': 'Obecné',
  'Allocation des textes': 'Přidělení textů',
  'Sélectionner un format du contenu': 'Vybrat formát obsahu',
  'Allocation aux rédacteurs': 'Přidělení autorům',

  '{{count}} textes disponibles':
    '{{count}} dostupných textů',

  'Sélectionner un rédacteur': 'Vybrat autora',
  'Nom du rédacteur': 'Jméno autora',
  'Date limite': 'Termín',
  'texte restant': 'zbývající text',
  'textes alloués': 'přidělené texty',

  'Article court - 300 mots': 'Krátký článek – 300 slov',
  'Article moyen - 600 mots': 'Střední článek – 600 slov',
  'Article long - 1000 words': 'Dlouhý článek – 1000 slov',
  'Youtube - 350 mots': 'YouTube – 350 slov',
  'Linkedin - 200 mots': 'LinkedIn – 200 slov',
  'X - 150 mots': 'X – 150 slov',
  'Personnalisé': 'Vlastní',

  'Voir plus': 'Zobrazit více',
  ' à votre ': ' k vašemu ',
  '{{count}} textes à livrer':
    '{{count}} textů k dodání',


'Nous contacter': 'Kontaktujte nás',
'Vous avez une question ou un problème ? Contactez-nous et nous vous répondrons dans les plus brefs délais.': 'Máte otázku nebo problém? Kontaktujte nás a odpovíme vám co nejdříve.',
'Sujet': 'Předmět',
'Message': 'Zpráva',
'Soumettre ma demande': 'Odeslat žádost',
'Veuillez sélectionner un sujet': 'Vyberte prosím předmět',
'Décrivez votre demande en détail...': 'Popište svou žádost podrobně...',
'Sélectionnez un sujet': 'Vyberte předmět',
'Autre': 'Jiné',
'Feedback': 'Zpětná vazba',
'Question': 'Otázka',
'Bug': 'Chyba',
'Le message doit contenir au moins 10 caractères': 'Zpráva musí obsahovat alespoň 10 znaků',
'Votre message a été envoyé avec succès. Nous vous répondrons dans les plus brefs délais.': 'Vaše zpráva byla úspěšně odeslána. Odpovíme vám co nejdříve.',
'Votre demande a bien été transmise à notre équipe support, qui vous répondra dans les plus brefs délais.': 'Vaše žádost byla úspěšně předána našemu týmu podpory, který vám co nejdříve odpoví.',
'Envoi en cours...': 'Odesílání...',
'Fermer': 'Zavřít',

'Créer un nouvel agent AI': 'Vytvořit nového AI agenta',
'Mission de l\'agent': 'Mise agenta',
'L\'agent générera du contenu original à partir de vos consignes.': 'Agent bude generovat originální obsah na základě vašich pokynů.',
'Informations générales': 'Obecné informace',
'Informations principales': 'Hlavní informace',
'Ton & audience': 'Tón a cílová skupina',
'Structure & rédaction': 'Struktura a psaní',
'Base de connaissances': 'Znalostní báze',
'Construction du contenu': 'Tvorba obsahu',
'Structure attendu': 'Očekávaná struktura',
'Cadre lexical': 'Lexikální rámec',
'Personnalisation avancée': 'Pokročilé přizpůsobení',
'Base de connaissance locale en ligne': 'Online místní znalostní báze',
'Glissez-déposez votre fichier': 'Přetáhněte soubor sem',
'Base de connaissance': 'Znalostní báze',
'Indiquez la liste des urls sur lesquels l’IA peut s’appuyer': 'Uveďte seznam URL, ze kterých může AI čerpat',
'Définissez le positionnement éditorial de votre agent afin qu’il adapte son ton,': 'Definujte redakční zaměření svého agenta tak, aby přizpůsobil svůj tón,',
'sa cible et son vocabulaire à votre activité.': 'svou cílovou skupinu a slovní zásobu vaší činnosti.',
'caractères': 'znaky',
'Nombre de textes maximum atteint.': 'Maximální počet textů dosáhnut. ',
'Vous avez réparti tous les textes disponibles pour ce projet.': 'Rozdělili jste všechny dostupné texty pro tento projekt.',
};
